<template>
  <div class="vx-row justify-between" id="BPM" oncontextmenu="return false">
    <left-preview-slider v-if="isShowComment" v-on:click="isOpenPreview = $event"></left-preview-slider>
    <Transition name="baikei-transition">
    <div class="vx-col md:w-1/3 mb-base" v-if="isOpenPreview && isShowComment">
      <vx-card title="BAIKEI">
        <img src="@/assets/images/baikei/screen-edit/bpm/bpm-01.jpg" width="100%" v-if="bpmPattern == 'bpm-01'" />
        <img src="@/assets/images/baikei/screen-edit/bpm/bpm-02.jpg" width="100%" v-if="bpmPattern == 'bpm-02'" />
        <img src="@/assets/images/baikei/screen-edit/bpm/bpm-03.jpg" width="100%" v-if="bpmPattern == 'bpm-03'" />
        <img src="@/assets/images/baikei/screen-edit/bpm/bpm-04.jpg" width="100%" v-if="bpmPattern == 'bpm-04'" />
        <img src="@/assets/images/baikei/screen-edit/bpm/bpm-05.jpg" width="100%" v-if="bpmPattern == 'bpm-05'" />
        <img src="@/assets/images/baikei/screen-edit/bpm/bpm-06.jpg" width="100%" v-if="bpmPattern == 'bpm-06'" />
        <img src="@/assets/images/baikei/screen-edit/bpm/bpm-07.jpg" width="100%" v-if="bpmPattern == 'bpm-07'" />
        <img src="@/assets/images/baikei/screen-edit/bpm/bpm-08.jpg" width="100%" v-if="bpmPattern == 'bpm-08'" />
        <img src="@/assets/images/baikei/screen-edit/bpm/bpm-09.jpg" width="100%" v-if="bpmPattern == 'bpm-09'" />
        <img src="@/assets/images/baikei/screen-edit/bpm/bpm-10.jpg" width="100%" v-if="bpmPattern == 'bpm-10'" />
        <img src="@/assets/images/baikei/screen-edit/bpm/bpm-11.jpg" width="100%" v-if="bpmPattern == 'bpm-11'" />
      </vx-card>
    </div>
     </Transition>
    <div class="vx-col mr-7 select flex-grow-width-make " :class="[!isShowComment && !isOpenPreview ? 'w-full' : !isShowComment ? 'w-57' : 'w-65']">
      <!-- start common  -->
      <vx-card class=" preview-edit-screen">
        <table :id="`${arrayCommentId[0]}`">
          <tr>
            <th style="width:20%" rowspan="2">売買代金</th>
            <th>総額</th>
            <td>
              <div class="flex-row">
                <div class="flex">
                    <div class="w-1/2">
                      <vs-input type="text" @blur="baibaidaikin_sogaku=formatIntegerAdvanced(baibaidaikin_sogaku, true, 12); lostFocus, focusOut()" @focus="onFocus('baibaidaikin_sogaku')" v-model="baibaidaikin_sogaku" name="baibaidaikin_sogaku" :maxlength="handleMaxLength(12, baibaidaikin_sogaku)"/>
                      <span class="tooltip-custom" :class="addPadding('baibaidaikin_sogaku')">{{showMaxlength(12, baibaidaikin_sogaku, 'baibaidaikin_sogaku', true)}}</span>
                    </div>
                    <span class="ml-6 m-auto">円</span>
                    <vs-checkbox @input="lostFocus" v-model="baibaidaikin_ikkatsukessai" @change="clearMoneyField"/>
                    <span class="ml-1 mr-16 m-auto">一括決済</span>
                </div>
                <div class="text-warning" v-if="formValidation.baibaidaikin_sogaku.isWarning">{{formValidation.baibaidaikin_sogaku.warningMsg}}</div>
              </div>
            </td>
          </tr>

          <tr>
            <th>消費税等相当額</th>
            <td>
              <div class="flex-row">
                <div class="flex">
                    <div class="w-1/2">
                      <vs-input @blur="baibaidaikin_shohizeisotogaku=formatIntegerAdvanced(baibaidaikin_shohizeisotogaku, true, 12), focusOut()" @focus="onFocus('baibaidaikin_shohizeisotogaku')"  type="text" v-model="baibaidaikin_shohizeisotogaku" name="baibaidaikin_shohizeisotogaku" :maxlength="handleMaxLength(12, baibaidaikin_shohizeisotogaku)" :disabled="!baibaidaikin_shohizeihyoji" />
                      <span class="tooltip-custom" :class="addPadding('baibaidaikin_shohizeisotogaku')">{{showMaxlength(12, baibaidaikin_shohizeisotogaku, 'baibaidaikin_shohizeisotogaku', true)}}</span>
                    </div>
                    <span class="ml-6 m-auto">円</span>

                    <vs-checkbox v-model="baibaidaikin_shohizeihyoji" @change="handleDeleteContentWhenClick" :disabled="baikeiNo == 1 || baikeiNo == 2 || baikeiNo == 3 || baikeiNo == 21 || baikeiNo == 22 || baikeiNo == 23 || baikeiNo == 31 || baikeiNo == 32 || baikeiNo == 33"/>
                    <span class="ml-1 mr-4 m-auto">消費税表示する</span>
                </div>
                <!-- <div class="text-warning" v-if="formValidation.baibaidaikin_shohizeisotogaku.isWarning">{{formValidation.baibaidaikin_shohizeisotogaku.warningMsg}}</div> -->
              </div>
            </td>
          </tr>
        </table>

        <table :id="`${arrayCommentId[1]}`">
          <tr>
            <th colspan="2" style="width: 20%">手付金</th>
            <th>本契約締結時支払い</th>
            <td>
              <div class="flex-row">
                <div class="flex">
                  <div class="w-1/2">
                    <vs-input type="text"
                              @blur="tetsukekin_teiketsu_haraigaku=formatIntegerAdvanced(tetsukekin_teiketsu_haraigaku, true, 12); lostFocus, focusOut()" @focus="onFocus('tetsukekin_teiketsu_haraigaku')"
                              v-model="tetsukekin_teiketsu_haraigaku"
                              name="tetsukekin_teiketsu_haraigaku"
                              :disabled="baibaidaikin_ikkatsukessai"
                              :maxlength="handleMaxLength(12, tetsukekin_teiketsu_haraigaku)" />
                    <span class="tooltip-custom" :class="addPadding('tetsukekin_teiketsu_haraigaku')">{{showMaxlength(12, tetsukekin_teiketsu_haraigaku, 'tetsukekin_teiketsu_haraigaku', true)}}</span>
                  </div>  
                  <span class="ml-6 m-auto">円</span>
                </div>
                <div class="text-warning" v-if="formValidation.tetsukekin_teiketsu_haraigaku.isWarning">{{formValidation.tetsukekin_teiketsu_haraigaku.warningMsg}}</div>
              </div>
            </td>
          </tr>
        </table>
        <table :id="`${arrayCommentId[2]}`">
          <tr>
            <th rowspan="2">内金</th>
            <th>第1回</th>
            <td colspan="2">
              <div class="flex pt-2">
                  <DatePickerCustom class="ml-2"
                                    v-model="naikin1_nengappi"
                                    name="naikin1_nengappi"
                                    :date="naikin1_nengappi"
                                    :checkboxvalue="naikin1_nengappi_checkbox"
                                    :cleardate="naikin1_nengappi_clear"
                                    v-on:change-checkbox="naikin1_nengappi_checkbox = $event"
                                    format="yyyy-MM-dd"
                                    separate="-"
                                    :disabled="baibaidaikin_ikkatsukessai"
                                    @lost-focus="lostFocus()"/>
              </div>
              <div class="text-warning ml-2" v-if="formValidation.naikin1_nengappi.isWarning">{{formValidation.naikin1_nengappi.warningMsg}}</div>
              <div class="text-danger ml-2" v-if="formValidation.naikin1_nengappi.isError">{{formValidation.naikin1_nengappi.errorMsg}}</div>
              <div class="flex pt-2">
                <div class="ml-2 w-2/3">
                  <vs-input type="text" :maxlength="handleMaxLength(12, naikin1_kingaku)" v-model="naikin1_kingaku" @blur="naikin1_kingaku=formatIntegerAdvanced(naikin1_kingaku, true, 12); lostFocus, focusOut()" @focus="onFocus('naikin1_kingaku')" :disabled="baibaidaikin_ikkatsukessai" />
                  <span class="tooltip-custom" :class="addPadding('naikin1_kingaku')">{{showMaxlength(12, naikin1_kingaku, 'naikin1_kingaku', true)}}</span>
                </div>
                <span class="ml-2 m-auto">円</span>
              </div>
            </td>
          </tr>

          <tr>
            <th>第２回</th>
            <td colspan="2">
              <div class="flex pt-2">
                  <DatePickerCustom class="ml-2"
                                    v-model="naikin2_nengappi"
                                    name="naikin2_nengappi"
                                    :date="naikin2_nengappi"
                                    :checkboxvalue="naikin2_nengappi_checkbox"
                                    :cleardate="naikin2_nengappi_clear"
                                    v-on:change-checkbox="naikin2_nengappi_checkbox = $event"
                                    format="yyyy-MM-dd"
                                    separate="-"
                                    :disabled="baibaidaikin_ikkatsukessai"
                                    @lost-focus="lostFocus()"/>
              </div>
              <div class="text-warning ml-2" v-if="formValidation.naikin2_nengappi.isWarning">{{formValidation.naikin2_nengappi.warningMsg}}</div>
              <div class="text-danger ml-2" v-if="formValidation.naikin2_nengappi.isError">{{formValidation.naikin2_nengappi.errorMsg}}</div>
              <div class="flex pt-2">
              <div class="ml-2 w-2/3 ">
                <vs-input type="text" :maxlength="handleMaxLength(12, naikin2_kingaku)" v-model="naikin2_kingaku" @blur="naikin2_kingaku=formatIntegerAdvanced(naikin2_kingaku, true, 12); lostFocus; focusOut()" @focus="onFocus('naikin2_kingaku')" :disabled="baibaidaikin_ikkatsukessai" />
                <span class="tooltip-custom" :class="addPadding('naikin2_kingaku')">{{showMaxlength(12, naikin2_kingaku, 'naikin2_kingaku', true)}}</span>
              </div>
                <span class="ml-2 m-auto">円</span>
              </div>
            </td>
          </tr>
        </table>
        <table :id="`${arrayCommentId[3]}`">
          <tr>
            <th colspan="2">残代金</th>
            <td colspan="2" style="width: 88%;">
              <div class="flex pt-2">
                  <DatePickerCustom class="ml-2"
                                    v-model="zandaikin_nengappi"
                                    name="zandaikin_nengappi"
                                    :date="zandaikin_nengappi"
                                    :checkboxvalue="zandaikin_nengappi_checkbox"
                                    :cleardate="zandaikin_nengappi_clear"
                                    v-on:change-checkbox="zandaikin_nengappi_checkbox = $event"
                                    format="yyyy-MM-dd"
                                    separate="-"
                                    @lost-focus="lostFocus()"
                                    :disabled="baibaidaikin_ikkatsukessai" />
              </div>
              <div class="text-warning ml-2" v-if="formValidation.zandaikin_nengappi.isWarning">{{formValidation.zandaikin_nengappi.warningMsg}}</div>
              <div class="text-danger ml-2" v-if="formValidation.zandaikin_nengappi.isError">{{formValidation.zandaikin_nengappi.errorMsg}}</div>
              <div class="flex-row pt-2">
                <div class="flex">
                  <div class="w-1/2">
                    <vs-input @blur="zandaikin_kingaku=formatMinus(zandaikin_kingaku, true, 12); lostFocus, focusOut()" @focus="onFocus('zandaikin_kingaku'); lostFocusMinus() "
                              type="text" class="ml-2" :maxlength="handleMaxLengthMinus(12, zandaikin_kingaku)"
                              v-model="zandaikin_kingaku"
                              name="zandaikin_kingaku"
                              :disabled="baibaidaikin_ikkatsukessai" />
                    <span class="tooltip-custom" :class="addPadding('zandaikin_kingaku')">{{showMaxlength(12, zandaikin_kingaku, 'zandaikin_kingaku', true, true)}}</span>
                  </div>
                  <span class="ml-2 m-auto">円</span>
                  <vs-button class="ml-6 m-auto btn-positive" color="positive" type="filled" text-color="#7367F0" :disabled="baibaidaikin_ikkatsukessai" @click="remainPaymentAmount(); lostFocus(); lostFocusMinus()">自動計算</vs-button>
                </div>
                <div class="text-warning ml-2" v-if="formValidation.zandaikin_kingaku.isWarning">{{formValidation.zandaikin_kingaku.warningMsg}}</div>
                <div class="text-error ml-2" v-if="error === true">{{messageError}}</div>
              </div>
            </td>
          </tr>
          <!-- end common  -->
        </table>
        <table :id="`${arrayCommentId[4]}`" v-if="bpmPattern === 'bpm-03' || bpmPattern === 'bpm-04' "> 
          <!-- start BPM 03 and 04 -->
          <tr>
            <th colspan="2">清算の対象となる土地（第4条第2項)</th>
            <td colspan="2">
              <div class="flex pt-2">
                <radio-box @input="lostFocus" v-model="seisantaishoutochi" vs-name="seisantaishoutochi" vs-value="0"
                @change="handleChange('seisantaishoutochi')">1.<span class="ml-2 m-auto">私道負担（道路境界線後退部分を含む）のない場合、上記土地全体</span></radio-box>
              </div>
              <div class="flex pt-2">
                <radio-box @input="lostFocus" v-model="seisantaishoutochi" vs-name="seisantaishoutochi" vs-value="1"
                @change="handleChange('seisantaishoutochi')">2.<span class="ml-2 m-auto">私道負担（道路境界線後退部分を含む）のある場合、それを除く土地部分</span></radio-box>
              </div>
              <div class="flex pt-2" style="align-items: flex-start;">
                <radio-box @input="lostFocus" v-model="seisantaishoutochi" vs-name="seisantaishoutochi" vs-value="2"
                @change="handleChange('seisantaishoutochi')" class=" mt-3">3.</radio-box>
                <div class="flex-row">
                  <vs-input class="ml-2 w-4/5" @blur="lostFocus, focusOut()" @focus="onFocus('seisantaishoutochi_sentaku3nyuryoku')" v-model="seisantaishoutochi_sentaku3nyuryoku" :disabled="seisantaishoutochi != '2' " maxlength="37" name="seisantaishoutochi_sentaku3nyuryoku"/>
                  <span class="tooltip-custom" :class="addPadding('seisantaishoutochi_sentaku3nyuryoku')">{{showMaxlength(37, seisantaishoutochi_sentaku3nyuryoku, 'seisantaishoutochi_sentaku3nyuryoku')}}</span>
                  <div class="text-warning ml-2" v-if="formValidation.seisantaishoutochi_sentaku3nyuryoku.isWarning">{{formValidation.seisantaishoutochi_sentaku3nyuryoku.warningMsg}}</div>
                </div>
              </div>
              <div class="text-warning" v-if="formValidation.seisantaishoutochi.isWarning">{{formValidation.seisantaishoutochi.warningMsg}}</div>
            </td>
          </tr>
          <tr>
            <th style="w-1/5">清算基準面積（<span v-if="baikeiNo == 1 || baikeiNo == 4 || baikeiNo == 21 || baikeiNo == 24 ||baikeiNo == 31 || baikeiNo == 34">第4条第4項</span>
            <span v-if="baikeiNo == 2 || baikeiNo == 5 || baikeiNo == 22 || baikeiNo == 25 || baikeiNo == 32 || baikeiNo == 35">第4条第3項</span>）</th>
            <td>
              <div class="flex-row">
                <div class="flex">
                  <div>
                    <vs-input @blur="seisankijunmenseki=formatNumber(seisankijunmenseki); lostFocus, focusOut()" @focus="onFocus('seisankijunmenseki')" type="text" v-model="seisankijunmenseki" name="seisankijunmenseki" :maxlength="handleMaxLength(11, seisankijunmenseki)"/>
                    <span class="tooltip-custom" :class="addPadding('seisankijunmenseki')">{{showMaxlength(11, seisankijunmenseki, 'seisankijunmenseki', true)}}</span>
                  </div>
                  <span class="ml-1 m-auto">㎡</span>
                </div>
                <div class="text-warning" v-if="formValidation.seisankijunmenseki.isWarning">{{formValidation.seisankijunmenseki.warningMsg}}</div>
              </div>
            </td>
            <th class="w-1/5">清算単価（<span v-if="baikeiNo == 1 || baikeiNo == 4 || baikeiNo == 21 || baikeiNo == 24 ||baikeiNo == 31 || baikeiNo == 34">第4条第4項</span>
            <span v-if="baikeiNo == 2 || baikeiNo == 5 || baikeiNo == 22 || baikeiNo == 25 || baikeiNo == 32 || baikeiNo == 35">第4条第3項</span>）</th>
            <td>
              <div class="flex-row">
                <div class="flex">
                  <span class="mr-1 m-auto">1㎡あたり</span>
                  <div class="flex-row">
                    <vs-input @blur="seisantanka=formatIntegerAdvanced(seisantanka, true, 12); lostFocus, focusOut()" @focus="onFocus('seisantanka')" type="text" v-model="seisantanka" name="seisantanka"
                    :maxlength="handleMaxLength(12, seisantanka)"/>
                    <span class="tooltip-custom" :class="addPadding('seisantanka')">{{showMaxlength(12, seisantanka, 'seisantanka', true)}}</span>
                    <div class="text-warning" v-if="formValidation.seisantanka.isWarning">{{formValidation.seisantanka.warningMsg}}</div>
                  </div>
                  <span class="ml-2 m-auto">円</span>
                </div>
              </div>
            </td>
          </tr>
          <!-- end BPM 03 and 04 -->
        </table>
        <table>
          <!-- start use BPM 09  -->
          <tr  :id="`${arrayCommentId[5]}`" v-if="bpmPattern === 'bpm-09'">
            <th style="width:233px" colspan="2">保証金返還請求権引継対価（第3条第2項）</th>
            <th class="w-1/6">残代金の支払いと同時</th>
            <td>
              <div class="flex-row">
                <div class="flex">
                  <div>
                    <vs-input type="text"
                              @blur="hoshokinhenkanseikyuken_hikitsugitaika=formatIntegerAdvanced(hoshokinhenkanseikyuken_hikitsugitaika, true, 12); lostFocus, focusOut()" @focus="onFocus('hoshokinhenkanseikyuken_hikitsugitaika')"
                              class="w-2/3"
                              v-model="hoshokinhenkanseikyuken_hikitsugitaika"
                              name="hoshokinhenkanseikyuken_hikitsugitaika"
                              :maxlength="handleMaxLength(12, hoshokinhenkanseikyuken_hikitsugitaika)" />
                    <span class="tooltip-custom" :class="addPadding('hoshokinhenkanseikyuken_hikitsugitaika')">{{showMaxlength(12, hoshokinhenkanseikyuken_hikitsugitaika, 'hoshokinhenkanseikyuken_hikitsugitaika', true)}}</span>
                  </div>
                  <span class="ml-6 m-auto">円</span>
                </div>
                <div class="text-warning" v-if="formValidation.hoshokinhenkanseikyuken_hikitsugitaika.isWarning">
                  {{formValidation.hoshokinhenkanseikyuken_hikitsugitaika.warningMsg}}
                </div>
              </div>
              </td>
          </tr>

          <!-- end use BPM  -->

          <!-- start common -->
          <tr :id="`${arrayCommentId[6]}`">
            <th style="width:148px" colspan="2">引渡日（<span v-if="baikeiNo < 7 || baikeiNo == 9 || baikeiNo == 10 || (baikeiNo >= 21 && baikeiNo <= 26) || baikeiNo == 29|| (baikeiNo >= 31 && baikeiNo <= 36) || baikeiNo >= 39">第7条</span>
            <span v-if="baikeiNo == 7 || baikeiNo == 8 || baikeiNo == 11 || baikeiNo == 27 || baikeiNo == 28 || baikeiNo == 37 || baikeiNo == 38">第6条</span>）</th>
            <td colspan="2">
              <div class="flex-row">
                <div class="flex pt-2">
                  <radio-box @input="lostFocus" v-model="hikiwatashibi_sentaku" vs-name="hikiwatashibi_sentaku" vs-value="0"
                  @change="handleChange('hikiwatashibi_sentaku')" >1.<span class="ml-2 m-auto">売買代金全額受領日</span></radio-box>
                </div>
                <div class="flex pt-2">
                  <radio-box @input="lostFocus" v-model="hikiwatashibi_sentaku" vs-name="hikiwatashibi_sentaku" vs-value="1"
                  @change="handleChange('hikiwatashibi_sentaku')" >2.</radio-box>
                  <div class="flex-row">
                    <vs-input class="ml-2 w-4/5"
                              @blur="lostFocus, focusOut()" @focus="onFocus('hikiwatashibi2_nyuryoku')"
                              :disabled="hikiwatashibi_sentaku != '1'"
                              v-model="hikiwatashibi2_nyuryoku"
                              name="hikiwatashibi2_nyuryoku" maxlength="26"/>
                    <span class="tooltip-custom" :class="addPadding('hikiwatashibi2_nyuryoku')">{{showMaxlength(26, hikiwatashibi2_nyuryoku, 'hikiwatashibi2_nyuryoku')}}</span>
                    <div class="text-warning ml-2" v-if="formValidation.hikiwatashibi2_nyuryoku.isWarning">{{formValidation.hikiwatashibi2_nyuryoku.warningMsg}}</div>
                  </div>
                </div>
                <div class="text-warning" v-if="formValidation.hikiwatashibi_sentaku.isWarning">{{formValidation.hikiwatashibi_sentaku.warningMsg}}</div>
              </div>
            </td>
          </tr>
          <!-- end common -->

          <!-- start 1 , 3 , 5, 6, 9 -->
          <tr :id="`${arrayCommentId[7]}`" v-if="bpmPattern === 'bpm-01' || bpmPattern === 'bpm-03' || bpmPattern === 'bpm-05' || bpmPattern === 'bpm-06' || bpmPattern === 'bpm-09' ">
            <th colspan="2">手付解除期日（<span v-if="baikeiNo < 4 || baikeiNo == 7 || baikeiNo == 8 || baikeiNo == 11 || (baikeiNo >= 21 && baikeiNo <= 23) || baikeiNo == 27  || baikeiNo == 28">第14条第1項</span>
            <span v-if="baikeiNo == 4 || baikeiNo == 5 || baikeiNo == 6 || baikeiNo == 9 || baikeiNo == 10 || baikeiNo == 24 || baikeiNo == 25 || baikeiNo == 26 || baikeiNo == 29 || baikeiNo == 34 || baikeiNo == 35 || baikeiNo == 36 || baikeiNo == 40">第15条第1項</span>）</th>
            <td colspan="2" style="width: 81.4%;">
                  <DatePickerCustom class="ml-2"
                                    v-model="tetsukekin_kaijokijitsu"
                                    :date="tetsukekin_kaijokijitsu"
                                    :checkboxvalue="tetsukekin_kaijokijitsu_checkbox"
                                    :cleardate="tetsukekin_kaijokijitsu_clear"
                                    v-on:change-checkbox="tetsukekin_kaijokijitsu_checkbox = $event"
                                    format="yyyy-MM-dd"
                                    separate="-"
                                    :disabled="baibaidaikin_ikkatsukessai"
                                    name="tetsukekin_kaijokijitsu"
                                    @lost-focus="lostFocus()"/>
              <div class="text-warning ml-2" v-if="formValidation.tetsukekin_kaijokijitsu.isWarning">
                {{formValidation.tetsukekin_kaijokijitsu.warningMsg}}
              </div>
              <div class="text-danger ml-2" v-if="formValidation.tetsukekin_kaijokijitsu.isError">{{formValidation.tetsukekin_kaijokijitsu.errorMsg}}</div>
            </td>
          </tr>
          <!-- end 1 , 3 , 5, 6, 9 -->


          <!-- start 10, 11 -->
          <tr :id="`${arrayCommentId[8]}`" v-if="bpmPattern === 'bpm-10' || bpmPattern === 'bpm-11' ">
            <th colspan="2">契約不適合責任期間起算の時（第12条第4項、第5講）</th>
            <td colspan="2" style="width: 88%;">
              <div class="flex pt-2">
                <radio-box @input="lostFocus" v-model="futekigosenkinin_kikankisan_sentaku" @change="handleChange('futekigosenkinin_kikankisan_sentaku')" vs-name="futekigosenkinin_kikankisan_sentaku" vs-value="0">1.<span class="ml-2 m-auto">第7条第2項の引渡完了日</span></radio-box>
              </div>
              <div class="flex pt-2">
                <radio-box @input="lostFocus" v-model="futekigosenkinin_kikankisan_sentaku" @change="handleChange('futekigosenkinin_kikankisan_sentaku')" vs-name="futekigosenkinin_kikankisan_sentaku" vs-value="1">2.<span class="ml-2 m-auto">住宅新築請負契約の請負人から売主への引渡しの時（</span></radio-box>
              </div>
              <div class="flex pt-2 w-3/4">
                <div>
                  <DatePickerCustom class="ml-12"
                  @lost-focus="lostFocus()"
                  v-model="futekigosenkinin_kikankisan_sentaku2_nengappi"
                  name="futekigosenkinin_kikankisan_sentaku2_nengappi"
                  format="yyyy-MM-dd"
                  separate="-"
                  :date="futekigosenkinin_kikankisan_sentaku2_nengappi"
                  :checkboxvalue="futekigosenkinin_kikankisan_sentaku2_nengappi_checkbox"
                  :cleardate="futekigosenkinin_kikankisan_sentaku2_nengappi_clear"
                  v-on:change-checkbox="futekigosenkinin_kikankisan_sentaku2_nengappi_checkbox = $event"
                  :disabled="futekigosenkinin_kikankisan_sentaku !== '1'"/>
                <div class="text-warning ml-12 mt-1" v-if="formValidation.futekigosenkinin_kikankisan_sentaku2_nengappi.isWarning">
                  {{formValidation.futekigosenkinin_kikankisan_sentaku2_nengappi.warningMsg}}
                </div>
                <div class="text-danger ml-12 mt-1" v-if="formValidation.futekigosenkinin_kikankisan_sentaku2_nengappi.isError">
                  {{formValidation.futekigosenkinin_kikankisan_sentaku2_nengappi.errorMsg}}
                </div>
                </div>
              </div>
              <div class="flex pt-2">
                <radio-box @input="lostFocus" v-model="futekigosenkinin_kikankisan_sentaku" @change="handleChange('futekigosenkinin_kikankisan_sentaku')" vs-name="futekigosenkinin_kikankisan_sentaku" vs-value="2">3.</radio-box>
                <div class="flex-row">
                  <vs-input @blur="lostFocus, focusOut()" @focus="onFocus('futekigosenkinin_kikankisan_sentaku3_nyuryoku')" class="ml-2 w-10/12" v-model="futekigosenkinin_kikankisan_sentaku3_nyuryoku" name="futekigosenkinin_kikankisan_sentaku3_nyuryoku" maxlength="37" :disabled="futekigosenkinin_kikankisan_sentaku !== '2'"/>
                  <span class="tooltip-custom" :class="addPadding('futekigosenkinin_kikankisan_sentaku3_nyuryoku')">{{showMaxlength(37, futekigosenkinin_kikankisan_sentaku3_nyuryoku, 'futekigosenkinin_kikankisan_sentaku3_nyuryoku')}}</span>
                  <div class="text-warning ml-2" v-if="formValidation.futekigosenkinin_kikankisan_sentaku3_nyuryoku.isWarning">
                    {{formValidation.futekigosenkinin_kikankisan_sentaku3_nyuryoku.warningMsg}}
                  </div>
                </div>
              </div>
              <div class="text-warning" v-if="formValidation.futekigosenkinin_kikankisan_sentaku.isWarning">{{formValidation.futekigosenkinin_kikankisan_sentaku.warningMsg}}</div>
            </td>
          </tr>
          <!-- end 10,11-->

          <!-- start common -->

          <tr :id="`${arrayCommentId[9]}`">
            <th colspan="2">違約金の額（<span v-if="baikeiNo < 4 || baikeiNo == 7 || baikeiNo == 8 || baikeiNo == 11 || (baikeiNo >= 21 && baikeiNo <= 23) || baikeiNo == 27  || baikeiNo == 28|| (baikeiNo >= 31 && baikeiNo <= 33) ||(baikeiNo >= 37 && baikeiNo <= 39) || baikeiNo == 41">第15条第2項</span>
            <span v-if="baikeiNo == 4 || baikeiNo == 5 || baikeiNo == 6 || baikeiNo == 9 || baikeiNo == 10 || baikeiNo == 24 || baikeiNo == 25 || baikeiNo == 26 || baikeiNo == 29 || (baikeiNo >= 34 && baikeiNo <= 36) || baikeiNo == 40">第16条第2項</span>）</th>
            <td colspan="2">
              <div>
                <div class="flex pt-2">
                  <radio-box @input="lostFocus" v-model="iyakukingaku_sentaku" vs-name="iyakukingaku_sentaku" vs-value="0"
                  @change="handleChange('iyakukingaku_sentaku')">1.<span class="ml-2 m-auto">手付金の額</span></radio-box>
                </div>
                <div class="flex pt-2">
                  <div class="flex mr-4">
                    <radio-box @input="lostFocus" v-model="iyakukingaku_sentaku" vs-name="iyakukingaku_sentaku" vs-value="1"
                    @change="handleChange('iyakukingaku_sentaku')">2.<span class="ml-2 m-auto">売買代金の</span></radio-box>
                  </div>
                  <div class="flex-row">
                    <div class="flex">
                      <div>
                        <vs-input type="text" :maxlength="handleMaxLength(3, iyakukingaku_sotogaku)"
                                  @blur="iyakukingaku_sotogaku=formatNumber(iyakukingaku_sotogaku, false); lostFocus, focusOut()" @focus="onFocus('iyakukingaku_sotogaku')"
                                  v-model="iyakukingaku_sotogaku"
                                  name="iyakukingaku_sotogaku"
                                  :disabled="iyakukingaku_sentaku != '1' "/>
                        <span class="tooltip-custom" :class="addPadding('iyakukingaku_sotogaku')">{{showMaxlength(3, iyakukingaku_sotogaku, 'iyakukingaku_sotogaku', true)}}</span>
                      </div>
                      <span class="ml-2 m-auto">％相当額</span>
                    </div>
                    <div class="text-warning" v-if="formValidation.iyakukingaku_sotogaku.isWarning">{{formValidation.iyakukingaku_sotogaku.warningMsg}}</div>
                  </div>
                </div>
                <div class="flex pt-2">
                  <radio-box @input="lostFocus" v-model="iyakukingaku_sentaku" vs-name="iyakukingaku_sentaku" vs-value="2"
                  @change="handleChange('iyakukingaku_sentaku')">3.</radio-box>
                  <div class="flex-row">
                    <vs-input class="ml-2 w-4/5 "
                     @blur="lostFocus, focusOut(), iyakukingaku3_nyuryoku=formatIntegerAdvanced(iyakukingaku3_nyuryoku, true, 12)" 
                     @focus="onFocus('iyakukingaku3_nyuryoku')" 
                     v-model="iyakukingaku3_nyuryoku" 
                     name="iyakukingaku3_nyuryoku" 
                     :disabled=" iyakukingaku_sentaku != '2' " 
                     :maxlength="handleMaxLength(12, iyakukingaku3_nyuryoku)" />
                    <span class="tooltip-custom" :class="addPadding('iyakukingaku3_nyuryoku')">{{showMaxlength(12, iyakukingaku3_nyuryoku, 'iyakukingaku3_nyuryoku', true)}}</span>
                    <div class="text-warning ml-2" v-if="formValidation.iyakukingaku3_nyuryoku.isWarning">{{formValidation.iyakukingaku3_nyuryoku.warningMsg}}</div>
                  </div>
                  <span class="ml-2 m-auto">円</span>
                </div>
              </div>
              <div class="text-warning" v-if="formValidation.iyakukingaku_sentaku.isWarning">{{formValidation.iyakukingaku_sentaku.warningMsg}}</div>
            </td>
          </tr>
        </table>

        <table :id="`${arrayCommentId[10]}`">
          <tr>
            <th style="width:50px" rowspan="5">融資</th>
            <th style="width:20%">融資利用の有無（<span v-if="baikeiNo < 4 || baikeiNo == 7 || baikeiNo == 8 || baikeiNo == 11 || (baikeiNo >= 21 && baikeiNo <= 23) || baikeiNo == 27  || baikeiNo == 28|| (baikeiNo >= 31 && baikeiNo <= 33) ||(baikeiNo >= 37 && baikeiNo <= 39) || baikeiNo == 41">第16条</span>
            <span v-if="baikeiNo == 4 || baikeiNo == 5 || baikeiNo == 6 || baikeiNo == 9 || baikeiNo == 10 || baikeiNo == 24 || baikeiNo == 25 || baikeiNo == 26 || baikeiNo == 29 || (baikeiNo >= 34 && baikeiNo <= 36) || baikeiNo == 40">第17条</span>）</th>
            <td >
              <div class="flex-row">
                <div class="flex pt-2 w-1/2">
                  <radio-box class="ml-2 m-auto" @input="lostFocus" v-model="yushiriyo_umu" vs-name="yushiriyo_umu" name="yushiriyo_umu" vs-value="1">1.有</radio-box>
                  <radio-box class="ml-2 m-auto" @input="lostFocus" v-model="yushiriyo_umu" vs-name="yushiriyo_umu" name="yushiriyo_umu" vs-value="0">2.無</radio-box>
                </div>
                <div class="text-warning ml-2" v-if="formValidation.yushiriyo_umu.isWarning">{{formValidation.yushiriyo_umu.warningMsg}}</div>
              </div>
            </td>
          </tr>

          <tr>
            <th>
              <div>申込先<br></div>
              <div class="pt-8 pb-8">融資承認取得期日 <br></div>
              <div>融資金額</div>
            </th>
            <td colspan="2">
              <div class="pt-2">
                <vs-input @blur="lostFocus, focusOut()" @focus="onFocus('yushiriyo_naiyo1_moshikomisaki')" class="ml-2 w-5/6 " v-model="yushiriyo_naiyo1_moshikomisaki"
                          name="yushiriyo_naiyo1_moshikomisaki"
                          :disabled="yushiriyo_umu !== '1'" maxlength="18" />
                <span class="tooltip-custom" :class="addPadding('yushiriyo_naiyo1_moshikomisaki')">{{showMaxlength(18, yushiriyo_naiyo1_moshikomisaki, 'yushiriyo_naiyo1_moshikomisaki')}}</span>
                <div class="text-warning ml-2" v-if="formValidation.yushiriyo_naiyo1_moshikomisaki.isWarning">{{formValidation.yushiriyo_naiyo1_moshikomisaki.warningMsg}}</div>
              </div>
              <div class="flex-row">
                <div class="flex pt-2">
                  <DatePickerCustom class="ml-2"
                                    @lost-focus="lostFocus()"
                                    v-model="yushiriyo_naiyo1_yushishonin_shutokukijitsu"
                                    :date="yushiriyo_naiyo1_yushishonin_shutokukijitsu"
                                    :checkboxvalue="yushiriyo_naiyo1_yushishonin_shutokukijitsu_checkbox"
                                    :cleardate="yushiriyo_naiyo1_yushishonin_shutokukijitsu_clear"
                                    v-on:change-checkbox="yushiriyo_naiyo1_yushishonin_shutokukijitsu_checkbox = $event"
                                    name="yushiriyo_naiyo1_yushishonin_shutokukijitsu"
                                    format="yyyy-MM-dd"
                                    separate="-"
                                    :disabled="yushiriyo_umu !== '1'" />
              </div>
              <div class="text-warning ml-2" v-if="formValidation.yushiriyo_naiyo1_yushishonin_shutokukijitsu.isWarning">
                {{formValidation.yushiriyo_naiyo1_yushishonin_shutokukijitsu.warningMsg}}
              </div>
              <div class="text-danger ml-2" v-if="formValidation.yushiriyo_naiyo1_yushishonin_shutokukijitsu.isError">
                {{formValidation.yushiriyo_naiyo1_yushishonin_shutokukijitsu.errorMsg}}
              </div>
              </div>
              <div class="flex-row">
                <div class="flex pt-2">
                  <div class="ml-2 w-1/3">
                    <vs-input type="text" :maxlength="handleMaxLength(12, yushiriyo_naiyo1_yushikingaku)"
                              @blur="yushiriyo_naiyo1_yushikingaku=formatIntegerAdvanced(yushiriyo_naiyo1_yushikingaku, true, 12); lostFocus, focusOut()" @focus="onFocus('yushiriyo_naiyo1_yushikingaku')"
                              v-model="yushiriyo_naiyo1_yushikingaku"
                              name="yushiriyo_naiyo1_yushikingaku"
                              :disabled="yushiriyo_umu !== '1'" />
                    <span class="tooltip-custom" :class="addPadding('yushiriyo_naiyo1_yushikingaku')">{{showMaxlength(12, yushiriyo_naiyo1_yushikingaku, 'yushiriyo_naiyo1_yushikingaku', true)}}</span>
                  </div>
                  <span class="ml-2 m-auto">円</span>
                </div>
                <div class="text-warning ml-2" v-if="formValidation.yushiriyo_naiyo1_yushikingaku.isWarning">{{formValidation.yushiriyo_naiyo1_yushikingaku.warningMsg}}</div>
              </div>
            </td>
          </tr>

          <tr>
            <th>
              <div>申込先 <br></div>
              <div class="pt-8 pb-8">融資承認取得期日 <br></div>
              <div>融資金額</div>
            </th>
            <td colspan="2">
              <div class="flex pt-2">
                <div class="ml-2 w-5/6 ">
                  <vs-input v-model="yushiriyo_naiyo2_moshikomisaki" @blur="focusOut()" @focus="onFocus('yushiriyo_naiyo2_moshikomisaki')" :disabled="yushiriyo_umu !== '1'" maxlength="18" />
                  <span class="tooltip-custom" :class="addPadding('yushiriyo_naiyo2_moshikomisaki')">{{showMaxlength(18, yushiriyo_naiyo2_moshikomisaki, 'yushiriyo_naiyo2_moshikomisaki')}}</span>
                </div>
              </div>
              <div class="flex pt-2">
                  <DatePickerCustom class="ml-2"
                                    v-model="yushiriyo_naiyo2_yushishonin_shutokukijitsu"
                                    :date="yushiriyo_naiyo2_yushishonin_shutokukijitsu"
                                    :checkboxvalue="yushiriyo_naiyo2_yushishonin_shutokukijitsu_checkbox"
                                    :cleardate="yushiriyo_naiyo2_yushishonin_shutokukijitsu_clear"
                                    v-on:change-checkbox="yushiriyo_naiyo2_yushishonin_shutokukijitsu_checkbox = $event"
                                    name="yushiriyo_naiyo2_yushishonin_shutokukijitsu"
                                    format="yyyy-MM-dd"
                                    separate="-"
                                    :disabled="yushiriyo_umu !== '1'"
                                    @lost-focus="lostFocus()"/>
              </div>
              <div class="text-warning ml-2" v-if="formValidation.yushiriyo_naiyo2_yushishonin_shutokukijitsu.isWarning">
                {{formValidation.yushiriyo_naiyo2_yushishonin_shutokukijitsu.warningMsg}}
              </div>
              <div class="text-danger ml-2" v-if="formValidation.yushiriyo_naiyo2_yushishonin_shutokukijitsu.isError">
                {{formValidation.yushiriyo_naiyo2_yushishonin_shutokukijitsu.errorMsg}}
              </div>
              <div class="flex pt-2">
                <div class="ml-2 w-1/3">
                  <vs-input type="text" :maxlength="handleMaxLength(12, yushiriyo_naiyo2_yushikingaku)"
                            v-model="yushiriyo_naiyo2_yushikingaku"
                            @blur="yushiriyo_naiyo2_yushikingaku=formatIntegerAdvanced(yushiriyo_naiyo2_yushikingaku, true, 12), focusOut()" @focus="onFocus('yushiriyo_naiyo2_yushikingaku')"                            
                            :disabled=" yushiriyo_umu !== '1'" />
                  <span class="tooltip-custom" :class="addPadding('yushiriyo_naiyo2_yushikingaku')">{{showMaxlength(12, yushiriyo_naiyo2_yushikingaku, 'yushiriyo_naiyo2_yushikingaku', true)}}</span>
                </div>
                <span class="ml-2 m-auto">円</span>
              </div>
            </td>
          </tr>

          <tr>
            <th>
              <div>申込先 <br></div>
              <div class="pt-8 pb-8">融資承認取得期日 <br></div>
              <div>融資金額</div>
            </th>
            <td colspan="2">
              <div class="flex pt-2">
                <div class="ml-2 w-5/6">
                  <vs-input @blur="focusOut()" @focus="onFocus('yushiriyo_naiyo3_moshikomisaki')" v-model="yushiriyo_naiyo3_moshikomisaki" :disabled=" yushiriyo_umu !== '1'" maxlength="18" />
                  <span class="tooltip-custom" :class="addPadding('yushiriyo_naiyo3_moshikomisaki')">{{showMaxlength(18, yushiriyo_naiyo3_moshikomisaki, 'yushiriyo_naiyo3_moshikomisaki')}}</span>
                </div>
              </div>
              <div class="flex pt-2">
                <DatePickerCustom class="ml-2"
                                  v-model="yushiriyo_naiyo3_yushishonin_shutokukijitsu"
                                  :date="yushiriyo_naiyo3_yushishonin_shutokukijitsu"
                                  :checkboxvalue="yushiriyo_naiyo3_yushishonin_shutokukijitsu_checkbox"
                                  :cleardate="yushiriyo_naiyo3_yushishonin_shutokukijitsu_clear"
                                  v-on:change-checkbox="yushiriyo_naiyo3_yushishonin_shutokukijitsu_checkbox = $event"
                                  name="yushiriyo_naiyo3_yushishonin_shutokukijitsu"
                                  format="yyyy-MM-dd"
                                  separate="-"
                                  :disabled="yushiriyo_umu !== '1'"
                                  @lost-focus="lostFocus()"/>
              </div>
              <div class="text-warning ml-2" v-if="formValidation.yushiriyo_naiyo3_yushishonin_shutokukijitsu.isWarning">
                {{formValidation.yushiriyo_naiyo3_yushishonin_shutokukijitsu.warningMsg}}
              </div>
              <div class="text-danger ml-2" v-if="formValidation.yushiriyo_naiyo3_yushishonin_shutokukijitsu.isError">
                {{formValidation.yushiriyo_naiyo3_yushishonin_shutokukijitsu.errorMsg}}
              </div>
              <div class="flex pt-2">
                <div class="ml-2 w-1/3">
                  <vs-input type="text" :maxlength="handleMaxLength(12, yushiriyo_naiyo3_yushikingaku)"
                            v-model="yushiriyo_naiyo3_yushikingaku"
                            @blur="yushiriyo_naiyo3_yushikingaku=formatIntegerAdvanced(yushiriyo_naiyo3_yushikingaku, true, 12), focusOut()" @focus="onFocus('yushiriyo_naiyo3_yushikingaku')"
                            :disabled="yushiriyo_umu !== '1'" />
                  <span class="tooltip-custom" :class="addPadding('yushiriyo_naiyo3_yushikingaku')">{{showMaxlength(12, yushiriyo_naiyo3_yushikingaku, 'yushiriyo_naiyo3_yushikingaku', true)}}</span>
                </div>
                <span class="ml-2 m-auto">円</span>
              </div>
            </td>
          </tr>

          <tr>
            <th>融資利用の特約に基づく契約解除期日（同条第2項）</th>
            <td colspan="2">
              <div class="flex pt-2">
                <DatePickerCustom class="ml-2"
                                  v-model="yushikeiyaku_kaijokijitsu"
                                  :date="yushikeiyaku_kaijokijitsu"
                                  :checkboxvalue="yushikeiyaku_kaijokijitsu_checkbox"
                                  :cleardate="yushikeiyaku_kaijokijitsu_clear"
                                  v-on:change-checkbox="yushikeiyaku_kaijokijitsu_checkbox = $event"
                                  name="yushikeiyaku_kaijokijitsu"
                                  format="yyyy-MM-dd"
                                  separate="-"
                                  @lost-focus="lostFocus()"
                                  :disabled="yushiriyo_umu !== '1'" />
              </div>
              <div class="text-warning ml-2" v-if="formValidation.yushikeiyaku_kaijokijitsu.isWarning">
                {{formValidation.yushikeiyaku_kaijokijitsu.warningMsg}}
              </div>
              <div class="text-danger ml-2" v-if="formValidation.yushikeiyaku_kaijokijitsu.isError">
                {{formValidation.yushikeiyaku_kaijokijitsu.errorMsg}}
              </div>
            </td>
          </tr>
          <!-- end common -->
        </table>
        <table :id="`${arrayCommentId[11]}`"  v-if="bpmPattern === 'bpm-05' || bpmPattern === 'bpm-06' || bpmPattern === 'bpm-07' || bpmPattern === 'bpm-08' ||bpmPattern === 'bpm-09' || bpmPattern === 'bpm-11' ">
          <!-- start 5 , 6, , 7, 8 , 9 ,11 -->
          <tr>
            <th colspan="2">貸借権譲渡承諾の特約に基づく契約解除期日（<span v-if="baikeiNo == 7 || baikeiNo == 8 || baikeiNo == 11 || baikeiNo == 27  || baikeiNo == 28 ||(baikeiNo >= 37 && baikeiNo <= 39) || baikeiNo == 41">第17条第2項</span>
            <span v-if="baikeiNo == 9 || baikeiNo == 10 || baikeiNo == 29|| baikeiNo == 40">第18条第2項</span>）</th>
            <td colspan="2" style="width: 87.5%;">
              <div class="flex-row">
                  <DatePickerCustom class="ml-2"
                                    v-model="taishakukenjotoshodakukeiyaku_kaijokijitsu"
                                    :date="taishakukenjotoshodakukeiyaku_kaijokijitsu"
                                    :checkboxvalue="taishakukenjotoshodakukeiyaku_kaijokijitsu_checkbox"
                                    v-on:change-checkbox="taishakukenjotoshodakukeiyaku_kaijokijitsu_checkbox = $event"
                                    name="taishakukenjotoshodakukeiyaku_kaijokijitsu"
                                    format="yyyy-MM-dd"
                                    separate="-"
                                    @lost-focus="lostFocus()"/>
                <div class="text-warning ml-2" v-if="formValidation.taishakukenjotoshodakukeiyaku_kaijokijitsu.isWarning">{{formValidation.taishakukenjotoshodakukeiyaku_kaijokijitsu.warningMsg}}</div>
                <div class="text-danger ml-2" v-if="formValidation.taishakukenjotoshodakukeiyaku_kaijokijitsu.isError">
                  {{formValidation.taishakukenjotoshodakukeiyaku_kaijokijitsu.errorMsg}}
                </div>
              </div>
            </td>
          </tr>

          <!-- end 5 , 6, , 7, 8 , 9 -->
        </table>
        <div><tr style="height:30px"></tr></div>
      </vx-card>

      <footer-button @cancel="popupActiveCancelForm = true" @save="checkSave()"></footer-button>

      <!-- Popup Cancel -->
      <vs-popup class="holamundo" title="キャンセル" :active.sync="popupActiveCancelForm" :button-close-hidden="true">
          <p class="my-4 font-bold text-lg">{{messageWhenCancel}}</p>
          <div class="flex justify-end">
            <vs-button class="btn-positive mr-8 btn-yes" @click="handleCancelSaveBPM">はい</vs-button>
            <vs-button class="btn-positive" color="positive" type="filled" text-color="#7367F0" @click="popupActiveCancelForm = false">いいえ</vs-button>
          </div>
      </vs-popup>

      <!-- Popup Save -->
      <vs-popup class="holamundo" title="保存" :active.sync="popupActiveSaveForm" :button-close-hidden="true">
          <p class="my-4 font-bold text-lg">{{messageWhenHanei}}</p>
          <div class="flex justify-end">
            <vs-button class="btn-positive mr-8 btn-yes" @click="handleSaveBPM">はい</vs-button>
            <vs-button class="btn-positive" color="positive" type="filled" text-color="#7367F0" @click="popupActiveSaveForm = false">いいえ</vs-button>
          </div>
      </vs-popup>

      <!-- Popup Error -->
      <vs-popup class="holamundo"
                title="保存"
                :active.sync="popupFormError"
                :button-close-hidden="true">
        <p class="my-4 font-bold text-lg">
          {{globalErrorMessage}}
        </p>
        <div class="flex justify-end">
          <vs-button class="btn-positive btn-yes" color="positive" type="filled" text-color="#7367F0" @click="popupFormError = false">はい</vs-button>
        </div>
      </vs-popup>
    </div>
    <Transition name="baikei-transition">
    <vx-card class="vx-col mb-base comment-frame" id="closeCommentSiderPattern" :class="isShowComment ? 'closeComment': 'showComment'" >
      <Comment @tickPart="tickPart" @showHightlightInPage="handleShowHightlightInPage" @commentData="getArrayHighlight" :pattern="bpmPattern"/>
    </vx-card>
    </Transition>
</div>

</template>

<script>
import _ from 'lodash'
import moment from 'moment'
import holiday_jp from '@holiday-jp/holiday_jp'
import DatePickerCustom from '../components/DatePickerCustom.vue'
import FooterButton from './components/FooterButton.vue'
import RadioBox from './components/RadioBox.vue'
import { SAVE_BPM, SAVE_EDIT_MODE, GET_BUNSHO, SAVE_BSC, SAVE_KEIYAKU} from '@/store/modules/keiyaku/actions.js'
import { MESSAGE } from '../constant/message_code'
import routeIfCodeNull from '@/mixins/routeIfCodeNull'
import utilitiesMethods from '@/mixins/utilitiesMethods'
import { SCREEN } from '../jsons-data/bunsho_template_const.json'
import {SAVE_JRB_M007_09, SAVE_JRB_M007_10, SAVE_JRB_M007_11, SAVE_JRB_M007_14, SAVE_JRB_M007_15} from '../store/modules/keiyaku/actions'
import LeftPreviewSlider from './components/LeftPreviewSlider.vue'
// import { 
//   SET_STATE_SHOW_COMMENT
// } from '@/store/modules/keiyaku/mutations'
import Comment from './comment'
import { bpm01Highlight, bpm02Highlight, bpm03Highlight, bpm04Highlight, bpm05Highlight, bpm06Highlight, bpm07Highlight, bpm08Highlight, bpm09Highlight, bpm10Highlight, bpm11Highlight } from '../constant/highlight'
import highlighter from '../mixins/highlighter'
export default {
  name: 'BPM',
  mixins: [routeIfCodeNull, utilitiesMethods, highlighter],
  components: {
    DatePickerCustom,
    FooterButton,
    RadioBox,
    LeftPreviewSlider,
    Comment
  },
  data() {
    return {
      arrayCommentId: [],
      arrayHighlightId: [],
      isOpenPreview: true,
      isShowComment: true,
      attentionWaringStatus: false,
      messageWhenCancel: MESSAGE.M1008,
      messageWhenHanei: MESSAGE.M1007,
      globalErrorMessage: MESSAGE.M1023,
      popupFormError: false,
      // data
      baibaidaikin_sogaku: null,
      baibaidaikin_ikkatsukessai: false,
      baibaidaikin_shohizeisotogaku: null,
      baibaidaikin_shohizeihyoji: false,
      tetsukekin_teiketsu_haraigaku: null,
      naikin1_nengappi: '',
      naikin1_nengappi_checkbox: false,
      naikin1_nengappi_clear: 0,
      naikin1_kingaku: null,
      naikin2_nengappi: '',
      naikin2_nengappi_checkbox: false,
      naikin2_nengappi_clear: 0,
      naikin2_kingaku: null,
      zandaikin_nengappi: '',
      zandaikin_nengappi_checkbox: false,
      zandaikin_nengappi_clear: 0,
      zandaikin_kingaku: null,

      seisantaishoutochi: null,
      seisantaishoutochi_sentaku3nyuryoku: '',
      seisankijunmenseki: null,
      seisantanka: null,

      hoshokinhenkanseikyuken_hikitsugitaika: '',
      hikiwatashibi_sentaku: null,
      hikiwatashibi2_nyuryoku: '',
      tetsukekin_kaijokijitsu: '',
      tetsukekin_kaijokijitsu_checkbox: false,
      tetsukekin_kaijokijitsu_clear: 0,

      futekigosenkinin_kikankisan_sentaku: null,
      futekigosenkinin_kikankisan_sentaku2_nengappi: '',
      futekigosenkinin_kikankisan_sentaku2_nengappi_checkbox: false,
      futekigosenkinin_kikankisan_sentaku2_nengappi_clear: 0,
      futekigosenkinin_kikankisan_sentaku3_nyuryoku: '',

      iyakukingaku_sentaku: null,
      iyakukingaku_sotogaku: null,
      iyakukingaku3_nyuryoku: '',

      yushiriyo_umu: null,
      yushiriyo_naiyo1_moshikomisaki: '',
      yushiriyo_naiyo1_yushishonin_shutokukijitsu: '',
      yushiriyo_naiyo1_yushishonin_shutokukijitsu_checkbox: false,
      yushiriyo_naiyo1_yushishonin_shutokukijitsu_clear: 0,
      yushiriyo_naiyo1_yushikingaku: null,
      yushiriyo_naiyo2_moshikomisaki: '',
      yushiriyo_naiyo2_yushishonin_shutokukijitsu: '',
      yushiriyo_naiyo2_yushishonin_shutokukijitsu_checkbox: false,
      yushiriyo_naiyo2_yushishonin_shutokukijitsu_clear: 0,
      yushiriyo_naiyo2_yushikingaku: '',
      yushiriyo_naiyo3_moshikomisaki: '',
      yushiriyo_naiyo3_yushishonin_shutokukijitsu: '',
      yushiriyo_naiyo3_yushishonin_shutokukijitsu_checkbox: false,
      yushiriyo_naiyo3_yushishonin_shutokukijitsu_clear: 0,
      yushiriyo_naiyo3_yushikingaku: null,
      yushikeiyaku_kaijokijitsu: '',
      yushikeiyaku_kaijokijitsu_checkbox: false,
      yushikeiyaku_kaijokijitsu_clear: 0,
      taishakukenjotoshodakukeiyaku_kaijokijitsu: '',
      taishakukenjotoshodakukeiyaku_kaijokijitsu_checkbox: false,

      popupActiveCancelForm: false,
      popupActiveSaveForm: false,

      checkValidate: false,
      checkError: false,
      error: false,
      essageError: '',
      formValidation: {
        baibaidaikin_sogaku: {
          warning: true,
          isWarning: false,
          warningMsg: MESSAGE.E8051
        },
        baibaidaikin_seigo: {
          warning: () => {

          },
          isWarning: false,
          warningMsg: MESSAGE.W4003
        },
        tetsukekin_teiketsu_haraigaku: {
          warning: () => {
            return !this.baibaidaikin_ikkatsukessai && (!this.tetsukekin_teiketsu_haraigaku
              || !this.tetsukekin_teiketsu_haraigaku.trim())
          },
          isWarning: false,
          warningMsg: MESSAGE.E8051
        },
        naikin1_nengappi: {
          warning: () => {
            this.formValidation.naikin1_nengappi.attentionWarning = false
            if (this.baibaidaikin_ikkatsukessai) {
              return false
            }
            if(!this.naikin1_nengappi && this.naikin2_nengappi) {
              this.formValidation.naikin1_nengappi.attentionWarning = true
              this.formValidation.naikin1_nengappi.warningMsg = MESSAGE.W4007
              return true
            }
            if (this.naikin1_nengappi && this.checkAfterZandaikin(this.naikin1_nengappi)) {
              this.formValidation.naikin1_nengappi.attentionWarning = true
              this.formValidation.naikin1_nengappi.warningMsg = MESSAGE.W4004
              return true
            }
            if(this.naikin1_nengappi && !this.naikin2_nengappi) {
              return false
            }
            if(this.naikin1_nengappi > this.naikin2_nengappi) {
              this.formValidation.naikin1_nengappi.attentionWarning = true
              this.formValidation.naikin1_nengappi.warningMsg = MESSAGE.W4009
              return true
            }
            return false
          },
          attentionWarning: false,
          isWarning: false,
          warningMsg: MESSAGE.W4004,
          error: () => {
            return this.isValidDate(this.naikin1_nengappi)
          },
          isError: false,
          errorMsg: MESSAGE.E8066
        },
        naikin2_nengappi: {
          warning: () => {
            this.formValidation.naikin2_nengappi.attentionWarning = false
            let tmp = false
            if (this.naikin2_nengappi && this.checkAfterZandaikin(this.naikin2_nengappi)) {
              this.formValidation.naikin2_nengappi.attentionWarning = true
              this.formValidation.naikin2_nengappi.warningMsg = MESSAGE.W4004
              tmp = true
            }
            return !this.baibaidaikin_ikkatsukessai && tmp
          },
          attentionWarning: false,
          isWarning: false,
          warningMsg: MESSAGE.W4004,
          error: () => {
            return this.isValidDate(this.naikin2_nengappi)
          },
          isError: false,
          errorMsg: MESSAGE.E8066
        },
        zandaikin_nengappi: {
          warning: () => {
            this.formValidation.zandaikin_nengappi.attentionWarning = false
            if (this.baibaidaikin_ikkatsukessai) {
              return false
            }
            if (!this.baibaidaikin_ikkatsukessai && !this.zandaikin_nengappi) {
              this.formValidation.zandaikin_nengappi.warningMsg = MESSAGE.E8051
              return true
            }
            const holiday = holiday_jp.between(new Date(this.zandaikin_nengappi), new Date(this.zandaikin_nengappi))
            const momentTime = moment(this.zandaikin_nengappi, 'YYYYMMDD')
            const day = momentTime.format('dddd')
            if (holiday.length > 0 || day === 'Sunday' || day === 'Saturday') {
              this.formValidation.zandaikin_nengappi.attentionWarning = true
              this.formValidation.zandaikin_nengappi.warningMsg = MESSAGE.W4006
            }
            return (holiday.length > 0 || day === 'Sunday' || day === 'Saturday')
          },
          attentionWarning: false,
          isWarning: false,
          warningMsg: MESSAGE.E8051,
          error: () => {
            return this.isValidDate(this.zandaikin_nengappi)
          },
          isError: false,
          errorMsg: MESSAGE.E8066
        },
        zandaikin_kingaku: {
          warning: () => {
            const baibai_daikin = this.baibaidaikin_sogaku ? this.baibaidaikin_sogaku.replace(/,/g, '') : 0
            const tetsukekin = this.tetsukekin_teiketsu_haraigaku ? this.tetsukekin_teiketsu_haraigaku.replace(/,/g, '') : 0
            const naikin1 = this.naikin1_kingaku ? this.naikin1_kingaku.replace(/,/g, '') : 0
            const naikin2 = this.naikin2_kingaku ? this.naikin2_kingaku.replace(/,/g, '') : 0
            const zandaikin = this.zandaikin_kingaku ? this.zandaikin_kingaku.replace(/,/g, '') : 0

            const gokei = +tetsukekin + +naikin1 + +naikin2 + +zandaikin
            this.formValidation.zandaikin_kingaku.attentionWarning = false
            if (!this.baibaidaikin_ikkatsukessai && !this.zandaikin_kingaku) {
              this.formValidation.zandaikin_kingaku.warningMsg = MESSAGE.E8051
            }
            if ((+baibai_daikin !== gokei) && !this.baibaidaikin_ikkatsukessai) {
              this.formValidation.zandaikin_kingaku.warningMsg = MESSAGE.W4003
              this.formValidation.zandaikin_kingaku.attentionWarning = true
            }

            return (!this.baibaidaikin_ikkatsukessai && !this.zandaikin_kingaku) || ((+baibai_daikin !== gokei) && !this.baibaidaikin_ikkatsukessai)
          },
          isWarning: false,
          warningMsg: MESSAGE.E8051
        },
        seisantaishoutochi: {
          patterns: ['bpm-03', 'bpm-04'],
          warning: true,
          isWarning: false,
          warningMsg: MESSAGE.E8051
        },
        seisantaishoutochi_sentaku3nyuryoku: {
          patterns: ['bpm-03', 'bpm-04'],
          warning: () => {
            return String(this.seisantaishoutochi) === '2' && (this.seisantaishoutochi_sentaku3nyuryoku === null || this.seisantaishoutochi_sentaku3nyuryoku === '')
          },
          isWarning: false,
          warningMsg: MESSAGE.E8051
        },
        hoshokinhenkanseikyuken_hikitsugitaika: {
          patterns: ['bpm-09'],
          warning: true,
          isWarning: false,
          warningMsg: MESSAGE.E8051
        },
        seisankijunmenseki: {
          patterns: ['bpm-03', 'bpm-04'],
          warning: true,
          isWarning: false,
          warningMsg: MESSAGE.E8051
        },
        seisantanka: {
          patterns: ['bpm-03', 'bpm-04'],
          warning: true,
          isWarning: false,
          warningMsg: MESSAGE.E8051
        },
        hikiwatashibi_sentaku: {
          warning: true,
          isWarning: false,
          warningMsg: MESSAGE.E8051
        },
        hikiwatashibi2_nyuryoku: {
          warning: () => {
            return String(this.hikiwatashibi_sentaku) === '1' && (this.hikiwatashibi2_nyuryoku === null || this.hikiwatashibi2_nyuryoku === '')
          },
          isWarning: false,
          warningMsg: MESSAGE.E8051
        },
        tetsukekin_kaijokijitsu: {
          patterns: ['bpm-01', 'bpm-03', 'bpm-05', 'bpm-06', 'bpm-09'],
          warning: () => {
            this.formValidation.tetsukekin_kaijokijitsu.attentionWarning = false
            if (this.baibaidaikin_ikkatsukessai) {
              return false
            }
            if (!this.baibaidaikin_ikkatsukessai && !this.tetsukekin_kaijokijitsu) {
              this.formValidation.tetsukekin_kaijokijitsu.warningMsg = MESSAGE.E8051
              return true
            }
            if (this.checkAfterZandaikin(this.tetsukekin_kaijokijitsu)) {
              this.formValidation.tetsukekin_kaijokijitsu.attentionWarning = true
              this.formValidation.tetsukekin_kaijokijitsu.warningMsg = MESSAGE.W4004
              return true
            }
            return false
          },
          attentionWarning: false,
          isWarning: false,
          warningMsg: MESSAGE.E8051,
          error: () => {
            return this.isValidDate(this.tetsukekin_kaijokijitsu)
          },
          isError: false,
          errorMsg: MESSAGE.E8066
        },
        futekigosenkinin_kikankisan_sentaku: {
          patterns: ['bpm-10', 'bpm-11'],
          warning: true,
          isWarning: false,
          warningMsg: MESSAGE.E8051
        },
        futekigosenkinin_kikankisan_sentaku2_nengappi: {
          patterns: ['bpm-10', 'bpm-11'],
          warning: () => {
            this.formValidation.futekigosenkinin_kikankisan_sentaku2_nengappi.attentionWarning = false
            if(!this.futekigosenkinin_kikankisan_sentaku2_nengappi) {
              this.formValidation.futekigosenkinin_kikankisan_sentaku2_nengappi.warningMsg = MESSAGE.E8051
            }
            return this.futekigosenkinin_kikankisan_sentaku　=== '1' && !this.futekigosenkinin_kikankisan_sentaku2_nengappi
          },
          attentionWarning: false,
          isWarning: false,
          warningMsg: MESSAGE.E8051,
          error: () => {
            return this.isValidDate(this.futekigosenkinin_kikankisan_sentaku2_nengappi)
          },
          isError: false,
          errorMsg: MESSAGE.E8066
        },
        futekigosenkinin_kikankisan_sentaku3_nyuryoku: {
          patterns: ['bpm-10', 'bpm-11'],
          warning: () => {
            return String(this.futekigosenkinin_kikankisan_sentaku) === '2' && (this.futekigosenkinin_kikankisan_sentaku3_nyuryoku === null || this.futekigosenkinin_kikankisan_sentaku3_nyuryoku === '')
          },
          isWarning: false,
          warningMsg: MESSAGE.E8051
        },
        iyakukingaku_sentaku: {
          warning: true,
          isWarning: false,
          warningMsg: MESSAGE.E8051
        },
        iyakukingaku_sotogaku: {
          warning: () => {
            return String(this.iyakukingaku_sentaku) === '1' && !this.iyakukingaku_sotogaku
          },
          isWarning: false,
          warningMsg: MESSAGE.E8051
        },
        iyakukingaku3_nyuryoku: {
          warning: () => {
            return String(this.iyakukingaku_sentaku) === '2' && !this.iyakukingaku3_nyuryoku
          },
          isWarning: false,
          warningMsg: MESSAGE.E8051
        },
        yushiriyo_umu: {
          warning: true,
          isWarning: false,
          warningMsg: MESSAGE.E8051
        },
        yushiriyo_naiyo1_moshikomisaki: {
          warning: () => {
            return String(this.yushiriyo_umu) === '1' && !this.yushiriyo_naiyo1_moshikomisaki
          },
          isWarning: false,
          warningMsg: MESSAGE.E8051
        },
        yushiriyo_naiyo1_yushishonin_shutokukijitsu: {
          warning: () => {
            this.formValidation.yushiriyo_naiyo1_yushishonin_shutokukijitsu.warningMsg = MESSAGE.E8051
            this.formValidation.yushiriyo_naiyo1_yushishonin_shutokukijitsu.attentionWarning = false
            if (!this.yushiriyo_naiyo1_yushishonin_shutokukijitsu && (this.yushiriyo_naiyo2_yushishonin_shutokukijitsu || this.yushiriyo_naiyo3_yushishonin_shutokukijitsu)) {
              this.formValidation.yushiriyo_naiyo1_yushishonin_shutokukijitsu.attentionWarning = true
              this.formValidation.yushiriyo_naiyo1_yushishonin_shutokukijitsu.warningMsg = MESSAGE.W4007
              return true
            }
            if (String(this.yushiriyo_umu) === '1' && !this.yushiriyo_naiyo1_yushishonin_shutokukijitsu) {
              this.formValidation.yushiriyo_naiyo1_yushishonin_shutokukijitsu.warningMsg = MESSAGE.E8051
              return true
            }
            if (this.yushiriyo_naiyo1_yushishonin_shutokukijitsu && this.checkAfterZandaikin(this.yushiriyo_naiyo1_yushishonin_shutokukijitsu)) {
              this.formValidation.yushiriyo_naiyo1_yushishonin_shutokukijitsu.attentionWarning = true
              this.formValidation.yushiriyo_naiyo1_yushishonin_shutokukijitsu.warningMsg = MESSAGE.W4004
              return true
            }
            if (this.yushiriyo_naiyo1_yushishonin_shutokukijitsu && !this.yushiriyo_naiyo2_yushishonin_shutokukijitsu) {
              if (this.yushiriyo_naiyo3_yushishonin_shutokukijitsu) {
                if(this.yushiriyo_naiyo1_yushishonin_shutokukijitsu <= this.yushiriyo_naiyo3_yushishonin_shutokukijitsu) {
                  return false
                } else {
                  this.formValidation.yushiriyo_naiyo1_yushishonin_shutokukijitsu.attentionWarning = true
                  this.formValidation.yushiriyo_naiyo1_yushishonin_shutokukijitsu.warningMsg = MESSAGE.W4009
                  return true
                }
              }
              return false
            }
            if (this.yushiriyo_naiyo1_yushishonin_shutokukijitsu > (this.yushiriyo_naiyo2_yushishonin_shutokukijitsu || this.yushiriyo_naiyo3_yushishonin_shutokukijitsu)) {
              this.formValidation.yushiriyo_naiyo1_yushishonin_shutokukijitsu.attentionWarning = true
              this.formValidation.yushiriyo_naiyo1_yushishonin_shutokukijitsu.warningMsg = MESSAGE.W4009
              return true
            }
            return false
          },
          attentionWarning: false,
          isWarning: false,
          warningMsg: MESSAGE.E8051,
          error: () => {
            return this.isValidDate(this.yushiriyo_naiyo1_yushishonin_shutokukijitsu)
          },
          isError: false,
          errorMsg: MESSAGE.E8066
        },
        yushiriyo_naiyo1_yushikingaku: {
          warning: () => {
            return String(this.yushiriyo_umu) === '1' && !this.yushiriyo_naiyo1_yushikingaku
          },
          isWarning: false,
          warningMsg: MESSAGE.E8051
        },
        yushiriyo_naiyo2_yushishonin_shutokukijitsu: {
          warning: () => {
            this.formValidation.yushiriyo_naiyo2_yushishonin_shutokukijitsu.attentionWarning = false
            let tmp = false
            if (this.yushiriyo_naiyo2_yushishonin_shutokukijitsu && this.checkAfterZandaikin(this.yushiriyo_naiyo2_yushishonin_shutokukijitsu)) {
              this.formValidation.yushiriyo_naiyo2_yushishonin_shutokukijitsu.attentionWarning = true
              this.formValidation.yushiriyo_naiyo2_yushishonin_shutokukijitsu.warningMsg = MESSAGE.W4004
              tmp = true
            }
            if (this.yushiriyo_naiyo2_yushishonin_shutokukijitsu && !this.yushiriyo_naiyo3_yushishonin_shutokukijitsu) {
              return false
            }
            if (this.yushiriyo_naiyo3_yushishonin_shutokukijitsu && !this.yushiriyo_naiyo2_yushishonin_shutokukijitsu) {
              this.formValidation.yushiriyo_naiyo2_yushishonin_shutokukijitsu.attentionWarning = true
              this.formValidation.yushiriyo_naiyo2_yushishonin_shutokukijitsu.warningMsg = MESSAGE.W4007
              return true
            }
            if (this.yushiriyo_naiyo2_yushishonin_shutokukijitsu > this.yushiriyo_naiyo3_yushishonin_shutokukijitsu) {
              this.formValidation.yushiriyo_naiyo2_yushishonin_shutokukijitsu.attentionWarning = true
              this.formValidation.yushiriyo_naiyo2_yushishonin_shutokukijitsu.warningMsg = MESSAGE.W4009
              return true
            }
            return this.yushiriyo_umu === '1' && tmp
          },
          attentionWarning: false,
          isWarning: false,
          warningMsg: MESSAGE.W4004,
          error: () => {
            return this.isValidDate(this.yushiriyo_naiyo2_yushishonin_shutokukijitsu)
          },
          isError: false,
          errorMsg: MESSAGE.E8066
        },
        yushiriyo_naiyo3_yushishonin_shutokukijitsu: {
          warning: () => {
            this.formValidation.yushiriyo_naiyo3_yushishonin_shutokukijitsu.attentionWarning = false
            let tmp = false
            if (this.yushiriyo_naiyo3_yushishonin_shutokukijitsu && this.checkAfterZandaikin(this.yushiriyo_naiyo3_yushishonin_shutokukijitsu)) {
              this.formValidation.yushiriyo_naiyo3_yushishonin_shutokukijitsu.attentionWarning = true
              this.formValidation.yushiriyo_naiyo3_yushishonin_shutokukijitsu.warningMsg = MESSAGE.W4004
              tmp = true
            }
            return this.yushiriyo_umu === '1' &&  tmp
          },
          attentionWarning: false,
          isWarning: false,
          warningMsg: MESSAGE.W4004,
          error: () => {
            return this.isValidDate(this.yushiriyo_naiyo3_yushishonin_shutokukijitsu)
          },
          isError: false,
          errorMsg: MESSAGE.E8066
        },
        taishakukenjotoshodakukeiyaku_kaijokijitsu: {
          patterns: ['bpm-05', 'bpm-06', 'bpm-07', 'bpm-08', 'bpm-09', 'bpm-11'],
          warning: true,
          attentionWarning: false,
          isWarning: false,
          warningMsg: MESSAGE.E8051,
          error: () => {
            return this.isValidDate(this.taishakukenjotoshodakukeiyaku_kaijokijitsu)
          },
          isError: false,
          errorMsg: MESSAGE.E8066
        },
        yushikeiyaku_kaijokijitsu: {
          warning: false,
          attentionWarning: false,
          isWarning: false,
          error: () => {
            return this.isValidDate(this.yushikeiyaku_kaijokijitsu)
          },
          isError: false,
          errorMsg: MESSAGE.E8066
        }
      },

      // Overloan
      overloanMessage : ''
    }
  },
  watch: {
    '$store.getters.getStateShowComment' (val) {
      this.isShowComment = val
    },
    '$store.getters.getLeftPreviewSliderStatus' (val) {
      this.isOpenPreview = val
    }
  },
  computed:{
    getStateShowComment() {
      return this.$store.getters.getStateShowComment
    },
    getLeftPreviewSliderStatus() {
      return this.$store.getters.getLeftPreviewSliderStatus
    },
    bpmPattern() {
      return _.get(this.$store.getters.pattern, 'baikei.bpm', null)
    },
    handleMaxLengthMinus() {
      return function(num, variable) {
        if (variable !== null) {
          const inputNum = String(variable)
          const comma = inputNum.match(/,/g) ? inputNum.match(/,/g).length : 0
          const dot = inputNum.match(/\./g) ? inputNum.match(/\./g).length : 0
          const minus = inputNum.match(/-/g) ? inputNum.match(/-/g).length : 0
          return comma + dot + num + minus
        }
        return num
      }
    },
    jrbData07_09() {
      return _.cloneDeep(_.get(this.$store.getters.keiyaku, 'jusetsu.jrb07_09', null))
    },
    jrbData07_10() {
      return _.cloneDeep(_.get(this.$store.getters.keiyaku, 'jusetsu.jrb07_10', null))
    },
    jrbData07_11() {
      return _.cloneDeep(_.get(this.$store.getters.keiyaku, 'jusetsu.jrb07_11', null))
    },
    jrbData07_14() {
      return _.cloneDeep(_.get(this.$store.getters.keiyaku, 'jusetsu.jrb07_14', null))
    },
    jrbData07_15() {
      return _.cloneDeep(_.get(this.$store.getters.keiyaku, 'jusetsu.jrb07_15', null))
    },
    baikeiNo() {
      return _.cloneDeep(_.get(this.$store.getters.pattern, 'keiyakushoNo', null))
    }
  },
  mounted() {
    this.getStyleForEditScreen()
    this.handleGetCommentId()
    this.isShowComment = this.getStateShowComment
    this.isOpenPreview = this.getLeftPreviewSliderStatus
    const bpm = _.cloneDeep(_.get(this.$store.getters.keiyaku, 'baikei.bpm', null))
    if(bpm) {
      this.baibaidaikin_sogaku = bpm.baibaidaikin_sogaku
      this.baibaidaikin_ikkatsukessai = bpm.baibaidaikin_ikkatsukessai
      this.baibaidaikin_shohizeisotogaku = bpm.baibaidaikin_shohizeisotogaku
      this.baibaidaikin_shohizeihyoji = bpm.baibaidaikin_shohizeihyoji
      this.tetsukekin_teiketsu_haraigaku = bpm.tetsukekin_teiketsu_haraigaku
      this.naikin1_nengappi = bpm.naikin1_nengappi
      this.naikin1_nengappi_checkbox = bpm.naikin1_nengappi_checkbox
      this.naikin1_kingaku = bpm.naikin1_kingaku
      this.naikin2_nengappi = bpm.naikin2_nengappi
      this.naikin2_nengappi_checkbox = bpm.naikin2_nengappi_checkbox
      this.naikin2_kingaku = bpm.naikin2_kingaku
      this.zandaikin_nengappi = bpm.zandaikin_nengappi
      this.zandaikin_nengappi_checkbox = bpm.zandaikin_nengappi_checkbox
      this.zandaikin_kingaku = bpm.zandaikin_kingaku
      // 03 04
      this.seisantaishoutochi = bpm.seisantaishoutochi
      this.seisantaishoutochi_sentaku3nyuryoku = bpm.seisantaishoutochi_sentaku3nyuryoku
      this.seisankijunmenseki = bpm.seisankijunmenseki
      this.seisantanka = bpm.seisantanka
      // 09
      this.hoshokinhenkanseikyuken_hikitsugitaika = bpm.hoshokinhenkanseikyuken_hikitsugitaika
      // common
      this.hikiwatashibi_sentaku = bpm.hikiwatashibi_sentaku
      this.hikiwatashibi2_nyuryoku = bpm.hikiwatashibi2_nyuryoku
      //  01 03 05
      this.tetsukekin_kaijokijitsu = bpm.tetsukekin_kaijokijitsu
      this.tetsukekin_kaijokijitsu_checkbox = bpm.tetsukekin_kaijokijitsu_checkbox
      // 11 10
      this.futekigosenkinin_kikankisan_sentaku = bpm.futekigosenkinin_kikankisan_sentaku
      this.futekigosenkinin_kikankisan_sentaku2_nengappi = bpm.futekigosenkinin_kikankisan_sentaku2_nengappi
      this.futekigosenkinin_kikankisan_sentaku2_nengappi_checkbox = bpm.futekigosenkinin_kikankisan_sentaku2_nengappi_checkbox
      this.futekigosenkinin_kikankisan_sentaku3_nyuryoku = bpm.futekigosenkinin_kikankisan_sentaku3_nyuryoku
      // common
      this.iyakukingaku_sentaku = bpm.iyakukingaku_sentaku
      this.iyakukingaku_sotogaku = bpm.iyakukingaku_sotogaku
      this.iyakukingaku3_nyuryoku = bpm.iyakukingaku3_nyuryoku
      // common
      this.yushiriyo_umu = bpm.yushiriyo_umu
      this.yushiriyo_naiyo1_moshikomisaki = bpm.yushiriyo_naiyo1_moshikomisaki
      this.yushiriyo_naiyo1_yushishonin_shutokukijitsu = bpm.yushiriyo_naiyo1_yushishonin_shutokukijitsu
      this.yushiriyo_naiyo1_yushishonin_shutokukijitsu_checkbox = bpm.yushiriyo_naiyo1_yushishonin_shutokukijitsu_checkbox
      this.yushiriyo_naiyo1_yushikingaku = bpm.yushiriyo_naiyo1_yushikingaku
      this.yushiriyo_naiyo2_moshikomisaki = bpm.yushiriyo_naiyo2_moshikomisaki
      this.yushiriyo_naiyo2_yushishonin_shutokukijitsu = bpm.yushiriyo_naiyo2_yushishonin_shutokukijitsu
      this.yushiriyo_naiyo2_yushishonin_shutokukijitsu_checkbox = bpm.yushiriyo_naiyo2_yushishonin_shutokukijitsu_checkbox
      this.yushiriyo_naiyo2_yushikingaku = bpm.yushiriyo_naiyo2_yushikingaku
      this.yushiriyo_naiyo3_moshikomisaki = bpm.yushiriyo_naiyo3_moshikomisaki
      this.yushiriyo_naiyo3_yushishonin_shutokukijitsu = bpm.yushiriyo_naiyo3_yushishonin_shutokukijitsu
      this.yushiriyo_naiyo3_yushishonin_shutokukijitsu_checkbox = bpm.yushiriyo_naiyo3_yushishonin_shutokukijitsu_checkbox
      this.yushiriyo_naiyo3_yushikingaku = bpm.yushiriyo_naiyo3_yushikingaku
      this.yushikeiyaku_kaijokijitsu = bpm.yushikeiyaku_kaijokijitsu
      this.yushikeiyaku_kaijokijitsu_checkbox = bpm.yushikeiyaku_kaijokijitsu_checkbox
      // 06 -> 09
      this.taishakukenjotoshodakukeiyaku_kaijokijitsu = bpm.taishakukenjotoshodakukeiyaku_kaijokijitsu
      this.taishakukenjotoshodakukeiyaku_kaijokijitsu_checkbox = bpm.taishakukenjotoshodakukeiyaku_kaijokijitsu_checkbox
    }

    const editMode = _.get(this.$store.getters.editMode, 'bpm', false)
    if (editMode) {
      setTimeout(() => {
        this.validateWarning()
      }, 200)
    }

    // Get Text Overloan
    const searchData = {
      type: 1,
      property_type_code: this.$store.getters.getSelectLandType,
      tab_code: SCREEN['M005-03-1'].tab,
      item_code: SCREEN['M005-03-1'].item,
      detail_item_code: SCREEN['M005-03-1'].detail_item,
      parent_category_id: 156,
      category_id: 1636,
      searchWord: ''
    }
    this.$store.dispatch(GET_BUNSHO, searchData).then(data => {
      const firstBunshoTemplates = data[0]
      if(firstBunshoTemplates) {
        this.overloanMessage =  firstBunshoTemplates.body
      }
    })
  },
  methods: {
    getArrayHighlight(data) {
      const idElement = []
      const block_list = data.block_list
      block_list.forEach(item => {
        item.part_list.map(ele => {
          idElement.push(ele.id_element)
        })
      })
      this.arrayHighlightId = idElement.filter(item => item.includes('bpm'))
    },
    handleChange(type) {
      switch(type) {
      case 'hikiwatashibi_sentaku':
        if(String(this.hikiwatashibi_sentaku) !== '1') {
          this.hikiwatashibi2_nyuryoku = ''
        }
        break
      case 'iyakukingaku_sentaku':
        if(String(this.iyakukingaku_sentaku) !== '1') {
          this.iyakukingaku_sotogaku = ''
        }
        if(String(this.iyakukingaku_sentaku) !== '2') {
          this.iyakukingaku3_nyuryoku = ''
        }
        break
      case 'seisantaishoutochi':
        if(String(this.seisantaishoutochi) !== '2') {
          this.seisantaishoutochi_sentaku3nyuryoku = ''
        }
        break
      case 'futekigosenkinin_kikankisan_sentaku':
        if (this.futekigosenkinin_kikankisan_sentaku !== '1') {
          this.futekigosenkinin_kikankisan_sentaku2_nengappi = ''
          this.futekigosenkinin_kikankisan_sentaku2_nengappi_checkbox = false
          this.futekigosenkinin_kikankisan_sentaku2_nengappi_clear += 1
        }
        if (this.futekigosenkinin_kikankisan_sentaku !== '2') {
          this.futekigosenkinin_kikankisan_sentaku3_nyuryoku = ''
        }
        break
      }
    },
    handleGetCommentId() {
      let bpmPatternHighlight = []
      switch (this.bpmPattern) {
      case 'bpm-01':
        bpmPatternHighlight = bpm01Highlight
        break
      case 'bpm-02':
        bpmPatternHighlight = bpm02Highlight
        break
      case 'bpm-03':
        bpmPatternHighlight = bpm03Highlight
        break
      case 'bpm-04':
        bpmPatternHighlight = bpm04Highlight
        break
      case 'bpm-05':
        bpmPatternHighlight = bpm05Highlight
        break
      case 'bpm-06':
        bpmPatternHighlight = bpm06Highlight
        break
      case 'bpm-07':
        bpmPatternHighlight = bpm07Highlight
        break
      case 'bpm-08':
        bpmPatternHighlight = bpm08Highlight
        break
      case 'bpm-09':
        bpmPatternHighlight = bpm09Highlight
        break
      case 'bpm-10':
        bpmPatternHighlight = bpm10Highlight
        break
      case 'bpm-11':
        bpmPatternHighlight = bpm11Highlight
        break
      default:
        break
      }
      let index = 0
      const bpmHighlight = bpmPatternHighlight.map(item => {
        if(item) {
          index = index + 1
          item = `${this.bpmPattern}-${index}`
        }
        return item
      })
      this.arrayCommentId = bpmHighlight
    },
    handleDeleteContentWhenClick() {
      if(this.baibaidaikin_shohizeihyoji === false) {
        this.baibaidaikin_shohizeisotogaku = ''
      }
    },
    clearMoneyField() {
      if (this.baibaidaikin_ikkatsukessai) {
        this.tetsukekin_teiketsu_haraigaku = null
        this.naikin1_kingaku = null
        this.naikin1_nengappi = ''
        this.naikin1_nengappi_checkbox = false
        this.naikin1_nengappi_clear += 1
        this.naikin2_kingaku = null
        this.naikin2_nengappi = ''
        this.naikin2_nengappi_checkbox = false
        this.naikin2_nengappi_clear += 1
        this.zandaikin_kingaku = null
        this.zandaikin_nengappi = ''
        this.zandaikin_nengappi_checkbox = false
        this.zandaikin_nengappi_clear += 1
        this.tetsukekin_kaijokijitsu = ''
        this.tetsukekin_kaijokijitsu_checkbox = false
        this.tetsukekin_kaijokijitsu_clear += 1
      }
    },
    remainPaymentAmount() {
      const baibaidaikin_sogaku = this.baibaidaikin_sogaku ? this.baibaidaikin_sogaku.replace(/,/g, '') : 0
      const tetsukekin_teiketsu_haraigaku = this.tetsukekin_teiketsu_haraigaku ? this.tetsukekin_teiketsu_haraigaku.replace(/,/g, '') : 0
      const naikin1_kingaku = this.naikin1_kingaku ? this.naikin1_kingaku.replace(/,/g, '') : 0
      const naikin2_kingaku = this.naikin2_kingaku ? this.naikin2_kingaku.replace(/,/g, '') : 0

      this.zandaikin_kingaku = +baibaidaikin_sogaku - +tetsukekin_teiketsu_haraigaku - +naikin1_kingaku - +naikin2_kingaku
      this.zandaikin_kingaku = this.formatMinus(this.zandaikin_kingaku, true, 12)
      this.lostFocus()
    },
    formatMinus(variable, withThousandSeparator = true, maxLength) {
      variable = variable !== null && variable !== undefined ? String(variable) : ''
      let cleanedNum = ''
      // remove all character without number
      if (variable[0] === '-') {
        cleanedNum = `-${variable.substring(1, variable.length).replace(/[^0-9+,+]/g, '')}`
      } else {
        cleanedNum = variable.replace(/[^0-9+,+]/g, '')
      }

      // remove commas, points
      cleanedNum = cleanedNum.replace(/,/g, '')
      cleanedNum = String(cleanedNum)
      if (variable[0] === '-') {
        cleanedNum = cleanedNum.substring(0, maxLength + 1)
      } else {
        cleanedNum = cleanedNum.substring(0, maxLength)
      }
      if (withThousandSeparator) {
        // add thousand separator
        cleanedNum = cleanedNum.replace(/\B(?=(\d{3})+(?!\d))/g, ',')
      }
      return cleanedNum
    },
    checkMinus() {
      const zandaikin = this.zandaikin_kingaku ? this.zandaikin_kingaku : ''
      if(zandaikin[0] === '-') {
        this.error = true
        this.messageError = '残代金が負の値になっております。売買代金・手付金・内金の値を確認してください。'
      } else {
        this.error = false
      }
      return this.error
    },
    checkAfterZandaikin(date) {
      if (this.zandaikin_nengappi && moment(this.zandaikin_nengappi).isBefore(date)) {
        return true
      }
      return false
    },
    isValidDate(date) {
      if (date) {
        return !(moment(date, 'YYYY-MM-DD', true).isValid() && moment(date, 'YYYY-MM-DD', true).isAfter(moment('1868-01-24')))
      }
      return false
    },
    handleSaveBPM() {
      const handle = () => {
        const bpm = {
        // common
          baibaidaikin_sogaku: this.baibaidaikin_sogaku,
          baibaidaikin_ikkatsukessai: this.baibaidaikin_ikkatsukessai,
          baibaidaikin_shohizeisotogaku: this.baibaidaikin_shohizeisotogaku,
          baibaidaikin_shohizeihyoji: this.baibaidaikin_shohizeihyoji,
          tetsukekin_teiketsu_haraigaku: this.tetsukekin_teiketsu_haraigaku,
          naikin1_nengappi: this.naikin1_nengappi,
          naikin1_nengappi_checkbox: this.naikin1_nengappi_checkbox,
          naikin1_kingaku: this.naikin1_kingaku,
          naikin2_nengappi: this.naikin2_nengappi,
          naikin2_nengappi_checkbox: this.naikin2_nengappi_checkbox,
          naikin2_kingaku: this.naikin2_kingaku,
          zandaikin_nengappi: this.zandaikin_nengappi,
          zandaikin_nengappi_checkbox: this.zandaikin_nengappi_checkbox,
          zandaikin_kingaku: this.zandaikin_kingaku,
          // 03 04
          seisantaishoutochi: this.seisantaishoutochi,
          seisantaishoutochi_sentaku3nyuryoku: this.seisantaishoutochi_sentaku3nyuryoku,
          seisankijunmenseki: this.seisankijunmenseki,
          seisantanka: this.seisantanka,
          // 09
          hoshokinhenkanseikyuken_hikitsugitaika: this.hoshokinhenkanseikyuken_hikitsugitaika,
          // common
          hikiwatashibi_sentaku: this.hikiwatashibi_sentaku,
          hikiwatashibi2_nyuryoku: this.hikiwatashibi2_nyuryoku,
          //  01 03 05
          tetsukekin_kaijokijitsu: this.tetsukekin_kaijokijitsu,
          tetsukekin_kaijokijitsu_checkbox: this.tetsukekin_kaijokijitsu_checkbox,
          // 11 10
          futekigosenkinin_kikankisan_sentaku: this.futekigosenkinin_kikankisan_sentaku,
          futekigosenkinin_kikankisan_sentaku2_nengappi: this.futekigosenkinin_kikankisan_sentaku2_nengappi,
          futekigosenkinin_kikankisan_sentaku2_nengappi_checkbox: this.futekigosenkinin_kikankisan_sentaku2_nengappi_checkbox,
          futekigosenkinin_kikankisan_sentaku3_nyuryoku: this.futekigosenkinin_kikankisan_sentaku3_nyuryoku,
          // common
          iyakukingaku_sentaku: this.iyakukingaku_sentaku,
          iyakukingaku_sotogaku: this.iyakukingaku_sotogaku,
          iyakukingaku3_nyuryoku: this.iyakukingaku3_nyuryoku,
          // commom
          yushiriyo_umu: this.yushiriyo_umu,
          yushiriyo_naiyo1_moshikomisaki: this.yushiriyo_naiyo1_moshikomisaki,
          yushiriyo_naiyo1_yushishonin_shutokukijitsu: this.yushiriyo_naiyo1_yushishonin_shutokukijitsu,
          yushiriyo_naiyo1_yushishonin_shutokukijitsu_checkbox: this.yushiriyo_naiyo1_yushishonin_shutokukijitsu_checkbox,
          yushiriyo_naiyo1_yushikingaku: this.yushiriyo_naiyo1_yushikingaku,
          yushiriyo_naiyo2_moshikomisaki: this.yushiriyo_naiyo2_moshikomisaki,
          yushiriyo_naiyo2_yushishonin_shutokukijitsu: this.yushiriyo_naiyo2_yushishonin_shutokukijitsu,
          yushiriyo_naiyo2_yushishonin_shutokukijitsu_checkbox: this.yushiriyo_naiyo2_yushishonin_shutokukijitsu_checkbox,
          yushiriyo_naiyo2_yushikingaku: this.yushiriyo_naiyo2_yushikingaku,
          yushiriyo_naiyo3_moshikomisaki: this.yushiriyo_naiyo3_moshikomisaki,
          yushiriyo_naiyo3_yushishonin_shutokukijitsu: this.yushiriyo_naiyo3_yushishonin_shutokukijitsu,
          yushiriyo_naiyo3_yushishonin_shutokukijitsu_checkbox: this.yushiriyo_naiyo3_yushishonin_shutokukijitsu_checkbox,
          yushiriyo_naiyo3_yushikingaku: this.yushiriyo_naiyo3_yushikingaku,
          yushikeiyaku_kaijokijitsu: this.yushikeiyaku_kaijokijitsu,
          yushikeiyaku_kaijokijitsu_checkbox: this.yushikeiyaku_kaijokijitsu_checkbox,
          // 06 -> 09
          taishakukenjotoshodakukeiyaku_kaijokijitsu: this.taishakukenjotoshodakukeiyaku_kaijokijitsu,
          taishakukenjotoshodakukeiyaku_kaijokijitsu_checkbox: this.taishakukenjotoshodakukeiyaku_kaijokijitsu_checkbox
        }
        const jrb07_09 = {
          baibaidaikin: this.baibaidaikin_sogaku,
          kingaku1: this.tetsukekin_teiketsu_haraigaku,
          uchishohizei_sotogaku: this.baibaidaikin_shohizeisotogaku,
          shohizei_hyoji: this.baibaidaikin_shohizeihyoji
        }
        const jrb07_10 = {
          yushiriyo_tokuyaku_kaijo_umusentaku: this.yushiriyo_umu,
          yushiriyo_tokuyaku_kaijo_nengappi : this.yushikeiyaku_kaijokijitsu,
          yushiriyo_tokuyaku_kaijo_nengappi_checkbox : this.yushikeiyaku_kaijokijitsu_checkbox,
          tetsukekaijo_nengappi : this.tetsukekin_kaijokijitsu,
          tetsukekaijo_nengappi_checkbox : this.tetsukekin_kaijokijitsu_checkbox,
          jotoshodaku_tokuyaku_kaijo_nengappi : this.taishakukenjotoshodakukeiyaku_kaijokijitsu,
          jotoshodaku_tokuyaku_kaijo_nengappi_checkbox : this.taishakukenjotoshodakukeiyaku_kaijokijitsu_checkbox
        }
        const jrb07_11 = {
          iyakukin_sentaku: this.iyakukingaku_sentaku,
          iyakukin_baibaidaikin_wariai: this.iyakukingaku_sotogaku,
          iyakukin_sonohoka_kingaku: this.iyakukingaku3_nyuryoku
        }

        const jrb07_14 = {
          assen1_kinyukikan : this.yushiriyo_naiyo1_moshikomisaki,
          assen1_shodakushonin_shutokukijitsu : this.yushiriyo_naiyo1_yushishonin_shutokukijitsu,
          assen1_shodakushonin_shutokukijitsu_checkbox : this.yushiriyo_naiyo1_yushishonin_shutokukijitsu_checkbox,
          assen1_kingaku : this.yushiriyo_naiyo1_yushikingaku,
          assen2_kinyukikan : this.yushiriyo_naiyo2_moshikomisaki,
          assen2_shodakushonin_shutokukijitsu : this.yushiriyo_naiyo2_yushishonin_shutokukijitsu,
          assen2_shodakushonin_shutokukijitsu_checkbox : this.yushiriyo_naiyo2_yushishonin_shutokukijitsu_checkbox,
          assen2_kingaku : this.yushiriyo_naiyo2_yushikingaku,
          assen3_kinyukikan : this.yushiriyo_naiyo3_moshikomisaki,
          assen3_shodakushonin_shutokukijitsu : this.yushiriyo_naiyo3_yushishonin_shutokukijitsu,
          assen3_shodakushonin_shutokukijitsu_checkbox : this.yushiriyo_naiyo3_yushishonin_shutokukijitsu_checkbox,
          assen3_kingaku : this.yushiriyo_naiyo3_yushikingaku
        }
        
        const jrb07_15 = {
          seisan_taishotochi_hani: this.seisantaishoutochi,
          seisan_taishotochi_hani_nyuryoku: this.seisantaishoutochi_sentaku3nyuryoku,
          seisan_kijun_menseki: this.seisankijunmenseki,
          seisan_tanka: this.seisantanka
        }

        const jrbData07_09 = _.merge(this.jrbData07_09, jrb07_09)
        const jrbData07_10 = _.merge(this.jrbData07_10, jrb07_10)
        const jrbData07_11 = _.merge(this.jrbData07_11, jrb07_11)
        const jrbData07_14 = _.merge(this.jrbData07_14, jrb07_14)
        const jrbData07_15 = _.merge(this.jrbData07_15, jrb07_15)
        this.handleOverloan()
        this.$store.dispatch(SAVE_BPM, bpm).then(() => {
          this.$store.dispatch(SAVE_EDIT_MODE, {'bpm': true})
          this.$store.dispatch(SAVE_JRB_M007_10, jrbData07_10)
          this.$store.dispatch(SAVE_JRB_M007_11, jrbData07_11)
          this.$store.dispatch(SAVE_JRB_M007_15, jrbData07_15)
          this.$store.dispatch(SAVE_JRB_M007_14, jrbData07_14)
          this.$store.dispatch(SAVE_JRB_M007_09, jrbData07_09).then(() => {
            this.$store.dispatch(SAVE_KEIYAKU).then(() => {
              this.popupActiveSaveForm = false
              this.$nextTick(() => {
                this.$router.push({name: 'baikei-m004-01'})
              })
            })
          })
        })
      }
      this.handleCheckCount(handle)
      this.popupActiveSaveForm = false
    },
    handleOverloan() {
      const editMode = _.get(this.$store.getters.editMode, 'bpm', false)
      if(editMode || this.baibaidaikin_sogaku_number === null || this.baibaidaikin_sogaku_number === '') {
        return
      }
      const yushiriyo_naiyo1_yushikingaku_number = this.yushiriyo_naiyo1_yushikingaku ?  +this.yushiriyo_naiyo1_yushikingaku.replaceAll(',', '') : 0
      const yushiriyo_naiyo2_yushikingaku_number = this.yushiriyo_naiyo2_yushikingaku ?  +this.yushiriyo_naiyo2_yushikingaku.replaceAll(',', '') : 0
      const yushiriyo_naiyo3_yushikingaku_number = this.yushiriyo_naiyo3_yushikingaku ?  +this.yushiriyo_naiyo3_yushikingaku.replaceAll(',', '') : 0
      const baibaidaikin_sogaku_number = this.baibaidaikin_sogaku ? +this.baibaidaikin_sogaku.replaceAll(',', '') : 0
      if(baibaidaikin_sogaku_number < (yushiriyo_naiyo1_yushikingaku_number + yushiriyo_naiyo2_yushikingaku_number + yushiriyo_naiyo3_yushikingaku_number)) {
        const { keiyaku } = this.$store.getters
        const bscData = keiyaku.baikei.bsc
        let tokuyakuBSC = []
        if (bscData && bscData.tokuyaku) {
          tokuyakuBSC = bscData.tokuyaku
        }
        tokuyakuBSC.push({'ikabesshi': false, 'tokuyaku': this.overloanMessage})
        const bscDataNew = _.merge(bscData, {'tokuyaku' : tokuyakuBSC})
        this.$store.dispatch(SAVE_BSC, bscDataNew)
      }
    },
    handleCancelSaveBPM() {
      this.handleSaveCountLocal()
      this.popupActiveCancelForm = false
      this.$nextTick(() => {
        this.$router.push({name: 'baikei-m004-01'})
      })
    },
    isNumber(value) {
      return value.replace(/[０-９]/g, s => String.fromCharCode(s.charCodeAt(0) - 65248)).replace(/\D/g, '')
    },
    highlight(key, isHighlight = true, eleIndex = null) {
      if (eleIndex === null) {
        // selectbox
        if (isHighlight) {
          $(`.v-select[name='${key}']`).find('.vs__dropdown-toggle').css({'background-color': 'rgb(255 197 54 / 60%)'})
        } else {
          $(`.v-select[name='${key}']`).find('.vs__dropdown-toggle').css({'background-color': 'inherit'})
        }
        // radiobox
        $('.con-vs-radio').each((idx, el) => {
          if ($(el).find(`input[name='${key}']`).length) {
            if (isHighlight) {
              $(el).find('span.vs-radio--borde').css({'border-color': '#eea840'})
            } else {
              $(el).find('span.vs-radio--borde').css({'border-color': '#c8c8c8'})
            }
          }
        })
        // checkbox
        $('.con-vs-checkbox').each((idx, el) => {
          if ($(el).find(`input[vs-name='${key}']`).length) {
            if (isHighlight) {
              $(el).find('span.vs-checkbox').css({'border-color': '#eea840'})
            } else {
              $(el).find('span.vs-checkbox').css({'border-color': '#c8c8c8'})
            }
          } else if ($(el).find(`input[name='${key}']`).length) {
            if (isHighlight) {
              $(el).find('span.vs-checkbox').css({'border-color': '#eea840'})
            } else {
              $(el).find('span.vs-checkbox').css({'border-color': '#c8c8c8'})
            }
          }
        })
        // vs-input
        const inputEl = $(`input[name='${key}']`)
        if (isHighlight) {
          inputEl.css({'background-color': 'rgb(255 197 54 / 60%)'})
        } else {
          inputEl.css({'background-color': 'inherit'})
        }
        // vs-textarea
        const textareaEl = $(`textarea[name='${key}']`)
        if (isHighlight) {
          textareaEl.css({'background-color': 'rgb(255 197 54 / 60%)'})
        } else {
          textareaEl.css({'background-color': 'inherit'})
        }
        // datepicker
        const selectEl = $(`div[datepicker='${key}']`).find('.vs__dropdown-toggle')
        const yearEl = $(`div[datepicker='${key}']`).find('input[name="year"]')
        const monthEl = $(`div[datepicker='${key}']`).find('input[name="month"]')
        const dayEl = $(`div[datepicker='${key}']`).find('input[name="day"]')
        if (isHighlight) {
          selectEl.css({'background-color': 'rgb(255 197 54 / 60%)'})
          yearEl.css({'background-color': 'rgb(255 197 54 / 60%)'})
          monthEl.css({'background-color': 'rgb(255 197 54 / 60%)'})
          dayEl.css({'background-color': 'rgb(255 197 54 / 60%)'})
        } else {
          selectEl.css({'background-color': 'inherit'})
          yearEl.css({'background-color': 'inherit'})
          monthEl.css({'background-color': 'inherit'})
          dayEl.css({'background-color': 'inherit'})
        }
      } else {
        // selectbox
        const selectboxEl = $(`.v-select[name='${key}']`)
        if (selectboxEl.length) {
          if (isHighlight) {
            $(selectboxEl[eleIndex]).find('.vs__dropdown-toggle').css({'background-color': 'rgb(255 197 54 / 60%)'})
          } else {
            $(selectboxEl[eleIndex]).find('.vs__dropdown-toggle').css({'background-color': 'inherit'})
          }
        }
        // radiobox
        $('.con-vs-radio').each((idx, el) => {
          const radioEl = $(el).find(`input[name='${key}']`)
          if (radioEl.length && $(radioEl[eleIndex]).length) {
            if (isHighlight) {
              $(radioEl[eleIndex]).find('span.vs-radio--borde').css({'border-color': '#eea840'})
            } else {
              $(radioEl[eleIndex]).find('span.vs-radio--borde').css({'border-color': '#c8c8c8'})
            }
          }
        })
        // vs-input
        const inputEl = $(`input[name='${key}']`)
        if (inputEl.length) {
          if (isHighlight) {
            $(inputEl[eleIndex]).css({'background-color': 'rgb(255 197 54 / 60%)'})
          } else {
            $(inputEl[eleIndex]).css({'background-color': 'inherit'})
          }
        }
        // vs-textarea
        const textareaEl = $(`textarea[name='${key}']`)
        if (textareaEl.length) {
          if (isHighlight) {
            $(textareaEl[eleIndex]).css({'background-color': 'rgb(255 197 54 / 60%)'})
          } else {
            $(textareaEl[eleIndex]).css({'background-color': 'inherit'})
          }
        }

        // datepicker
        if ($(`div[datepicker='${key}']`).length) {
          const selectEl = $(`div[datepicker='${key}']`)[eleIndex].find('.vs__dropdown-toggle')
          const yearEl = $(`div[datepicker='${key}']`)[eleIndex].find('input[name="year"]')
          const monthEl = $(`div[datepicker='${key}']`)[eleIndex].find('input[name="month"]')
          const dayEl = $(`div[datepicker='${key}']`)[eleIndex].find('input[name="day"]')
          if (isHighlight) {
            selectEl.css({'background-color': 'rgb(255 197 54 / 60%)'})
            yearEl.css({'background-color': 'rgb(255 197 54 / 60%)'})
            monthEl.css({'background-color': 'rgb(255 197 54 / 60%)'})
            dayEl.css({'background-color': 'rgb(255 197 54 / 60%)'})
          } else {
            selectEl.css({'background-color': 'inherit'})
            yearEl.css({'background-color': 'inherit'})
            monthEl.css({'background-color': 'inherit'})
            dayEl.css({'background-color': 'inherit'})
          }
        }
      }
    },
    validateWarning() {
      const context = this
      this.hasWarning = false
      this.attentionWaringStatus = false
      Object.keys(this.formValidation).forEach(key => {
        this.formValidation[key].isWarning = false
        if (!this.formValidation[key].patterns || !this.formValidation[key].patterns.length
          || this.formValidation[key].patterns.includes(this.bpmPattern)) {
          // ARRAY
          if (this.formValidation[key].elements) {
            this.formValidation[key].elements.forEach((child, idx) => {
              Object.keys(child).forEach(childKey => {
                if (typeof (context.formValidation[key].elements[idx][childKey].warning) === 'function' && this.formValidation[key].elements[idx][childKey].warning(idx)) {
                  context.formValidation[key].elements[idx][childKey].isWarning = true
                  context.highlight(childKey, true, idx)
                  context.hasWarning = true
                  context.messageWhenHanei = MESSAGE.M1017
                } else if (typeof (context.formValidation[key].elements[idx][childKey].warning) !== 'function'
                  && (context[key][idx][childKey] === null || context[key][idx][childKey] === undefined
                  || context[key][idx][childKey] === '' || context[key][idx][childKey] === false
                  || context[key][idx][childKey] === '　')) {
                  context.formValidation[key].elements[idx][childKey].isWarning = true
                  context.highlight(childKey, true, idx)
                  context.hasWarning = true
                  context.messageWhenHanei = MESSAGE.M1017
                } else {
                  context.formValidation[key].elements[idx][childKey].isWarning = false
                  context.highlight(childKey, false, idx)
                }
              })
            })
          } else if (typeof (this.formValidation[key].warning) === 'function' && this.formValidation[key].warning()) {
            this.formValidation[key].isWarning = true
            if(this.formValidation[key].attentionWarning) {
              this.attentionWaringStatus = true
            }else{
              this.hasWarning = true
            }
            this.highlight(key)
          } else if (typeof (this.formValidation[key].warning) !== 'function' && this.formValidation[key].warning
            && (this[key] === null || this[key] === undefined || this[key] === '' || this[key] === false || this[key] === '　')) {
            this.formValidation[key].isWarning = true
            this.highlight(key)
            this.hasWarning = true
            this.messageWhenHanei = MESSAGE.M1017
          } else {
            this.highlight(key, false)
          }
        }
      })
      this.checkValidate = true
      return this.hasWarning
    },
    validateError() {
      let hasError = false
      const filterErrorKeys = Object.keys(this.formValidation).filter(key => this.formValidation[key].error)
      filterErrorKeys.forEach(key => {
        if (this.formValidation[key].error()) {
          this.formValidation[key].isError = true
          hasError = true
        } else {
          this.formValidation[key].isError = false
        }
      })
      this.checkValidate = true
      return hasError
    },
    async checkSave() {
      const hasError = await this.validateError()
      if (hasError) {
        this.popupFormError = true
        return false
      }
      const hasMinus = await this.checkMinus()
      if(hasMinus) {
        this.popupFormError = true
        return false
      }
      await this.validateWarning()
      if(this.hasWarning && this.attentionWaringStatus) {
        this.messageWhenHanei = MESSAGE.M1019
      } else if(this.hasWarning) {
        this.messageWhenHanei = MESSAGE.M1017
      } else if(this.attentionWaringStatus) {
        this.messageWhenHanei = MESSAGE.M1018
      } else {
        this.messageWhenHanei = MESSAGE.M1007
      }
      this.popupActiveSaveForm = true
    },
    lostFocus() {
      if (this.checkValidate === true) {
        setTimeout(() => {
          this.validateError()
          this.validateWarning()
        }, 20)
      }
    },
    lostFocusMinus() {
      if (this.checkValidate === true) {
        this.checkMinus()
      }
    },
    tickPart(partName) {
      console.log(partName)
    },
    focusOut() {
      this.currentFocus = 0
      this.lostFocus()
    },
    handleShowHightlightInPage(highlight) {
      const idHightlighted = this.arrayHighlightId
      this.handleShowHightlightInPageMixin(highlight, idHightlighted)
    }
  }
}

</script>

<style scoped>
.text-error{
  color: red;
}

#BPM {
   word-wrap: break-word;
   display: flex;
}

.preview{
  width: 400px;
  height: 600px;
}

.background-style{
  background-color: white;
  padding: 10px;
  border: 2px solid #eeeeee;
  border-radius: 5px;
}

.input1-width{
  width: 50px;
}

.input2-width{
  width: 90px;
}

.sytle-button{
  display: flex;
  justify-content: flex-end;
  margin: 30px;
  gap: 30px;
}

table th {
  width: 130px;
}

table {
  font-family: arial, sans-serif;
  border-collapse: collapse;
  width: 100%;
}

td, th {
  border: 1px solid #dddddd;
  text-align: left;
  padding: 8px;
}
.btn-positive {
  border: 1px solid #7367F0;
}
.baikei-transition-enter-active {
  transition: all 0.25s ease-out;
}

.baikei-transition-leave-active {
  transition: all 0.25s ease-in;
}

.baikei-transition-enter,
.baikei-transition-leave-to {
  transform: translateX(-50px);
  opacity: 0;
  width: 0% !important;
}
.flex-grow-width-make {
  flex-grow: 1;
  flex-basis: 57%;
  min-width: 57%;
}
.preview-edit-screen {
  overflow: scroll;
  height: 615px;
  margin-top: 0.75rem;
}

.comment-frame {
  overflow: scroll;
  height: 615px;
  margin-top: 0.75rem;
}
.w-57 {
  width: 57%;
}
.w-65 {
  width: 65%;
}
</style>
